/* tslint:disable */
/* eslint-disable */
/**
 * Platypus API
 * Platypus Platform
 *
 * The version of the OpenAPI document: 0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AccessTokenResponse
 */
export interface AccessTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof AccessTokenResponse
     */
    'access_token': string;
    /**
     * 
     * @type {string}
     * @memberof AccessTokenResponse
     */
    'token_type': string;
    /**
     * 
     * @type {number}
     * @memberof AccessTokenResponse
     */
    'expires_in': number;
}
/**
 * 
 * @export
 * @interface AddOrganizationRequest
 */
export interface AddOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof AddOrganizationRequest
     */
    'organization_id': string;
}
/**
 * 
 * @export
 * @interface AddVerticalRequest
 */
export interface AddVerticalRequest {
    /**
     * 
     * @type {string}
     * @memberof AddVerticalRequest
     */
    'population_vertical_id': string;
}
/**
 * 
 * @export
 * @interface AssessmentCreate
 */
export interface AssessmentCreate {
    /**
     * 
     * @type {string}
     * @memberof AssessmentCreate
     */
    'standard'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentCreate
     */
    'standard_name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AssessmentCreate
     */
    'version'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentCreate
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentCreate
     */
    'organization'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentCreate
     */
    'date'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssessmentCreate
     */
    'scores_checked'?: boolean | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AssessmentCreate
     */
    'check_values'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssessmentCreate
     */
    'grade_sheets'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssessmentCreate
     */
    'scores'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface AssessmentResponse
 */
export interface AssessmentResponse {
    /**
     * 
     * @type {string}
     * @memberof AssessmentResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentResponse
     */
    'owner': string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentResponse
     */
    'standard': string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentResponse
     */
    'standard_id': string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentResponse
     */
    'date': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssessmentResponse
     */
    'scores_checked'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentResponse
     */
    'organization'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssessmentResponse
     */
    'grade_sheets'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface AssessmentScoreResponse
 */
export interface AssessmentScoreResponse {
    /**
     * 
     * @type {string}
     * @memberof AssessmentScoreResponse
     */
    'status': string;
    /**
     * 
     * @type {Array<ScoreResponse>}
     * @memberof AssessmentScoreResponse
     */
    'activity_scores': Array<ScoreResponse>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AssessmentScoreResponse
     */
    'check_values'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface ConversionRequest
 */
export interface ConversionRequest {
    [key: string]: any;

    /**
     * Current BSIMM version
     * @type {number}
     * @memberof ConversionRequest
     */
    'original_version': number;
    /**
     * Target BSIMM version
     * @type {number}
     * @memberof ConversionRequest
     */
    'target_version': number;
}
/**
 * 
 * @export
 * @interface EnrollRequest
 */
export interface EnrollRequest {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof EnrollRequest
     */
    'user': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface GradeSheetResponse
 */
export interface GradeSheetResponse {
    /**
     * 
     * @type {string}
     * @memberof GradeSheetResponse
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof GradeSheetResponse
     */
    'file_path': string;
    /**
     * 
     * @type {string}
     * @memberof GradeSheetResponse
     */
    'grader': string;
    /**
     * 
     * @type {string}
     * @memberof GradeSheetResponse
     */
    'assessment': string;
    /**
     * 
     * @type {Array<RedactedIndividualScoreResponse>}
     * @memberof GradeSheetResponse
     */
    'scores'?: Array<RedactedIndividualScoreResponse>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof GradeSheetResponse
     */
    'check_values'?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof GradeSheetResponse
     */
    'scores_checked'?: boolean;
}
/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * 
 * @export
 * @interface Meta
 */
export interface Meta {
    /**
     * 
     * @type {number}
     * @memberof Meta
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof Meta
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof Meta
     */
    'totalPages': number;
    /**
     * 
     * @type {number}
     * @memberof Meta
     */
    'totalItems': number;
}
/**
 * 
 * @export
 * @interface OrganizationCreate
 */
export interface OrganizationCreate {
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreate
     */
    'domain': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationCreate
     */
    'owner'?: string | null;
}
/**
 * 
 * @export
 * @interface OrganizationResponse
 */
export interface OrganizationResponse {
    /**
     * 
     * @type {string}
     * @memberof OrganizationResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationResponse
     */
    'owner'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationResponse
     */
    'domain': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationResponse
     */
    'assessments'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationResponse
     */
    'verticals'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface PaginatedResponseAssessmentResponse
 */
export interface PaginatedResponseAssessmentResponse {
    /**
     * 
     * @type {Meta}
     * @memberof PaginatedResponseAssessmentResponse
     */
    'meta': Meta;
    /**
     * 
     * @type {Array<AssessmentResponse>}
     * @memberof PaginatedResponseAssessmentResponse
     */
    'data': Array<AssessmentResponse>;
}
/**
 * 
 * @export
 * @interface PaginatedResponseOrganizationResponse
 */
export interface PaginatedResponseOrganizationResponse {
    /**
     * 
     * @type {Meta}
     * @memberof PaginatedResponseOrganizationResponse
     */
    'meta': Meta;
    /**
     * 
     * @type {Array<OrganizationResponse>}
     * @memberof PaginatedResponseOrganizationResponse
     */
    'data': Array<OrganizationResponse>;
}
/**
 * 
 * @export
 * @interface PaginatedResponseStandardEntryResponse
 */
export interface PaginatedResponseStandardEntryResponse {
    /**
     * 
     * @type {Meta}
     * @memberof PaginatedResponseStandardEntryResponse
     */
    'meta': Meta;
    /**
     * 
     * @type {Array<StandardEntryResponse>}
     * @memberof PaginatedResponseStandardEntryResponse
     */
    'data': Array<StandardEntryResponse>;
}
/**
 * 
 * @export
 * @interface PopulationResponse
 */
export interface PopulationResponse {
    /**
     * 
     * @type {string}
     * @memberof PopulationResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PopulationResponse
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PopulationVerticalResponse
 */
export interface PopulationVerticalResponse {
    /**
     * 
     * @type {string}
     * @memberof PopulationVerticalResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PopulationVerticalResponse
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof PopulationVerticalResponse
     */
    'population_size': number;
    /**
     * 
     * @type {string}
     * @memberof PopulationVerticalResponse
     */
    'population'?: string | null;
}
/**
 * 
 * @export
 * @interface RedactedIndividualScoreResponse
 */
export interface RedactedIndividualScoreResponse {
    /**
     * 
     * @type {string}
     * @memberof RedactedIndividualScoreResponse
     */
    'activity': string;
    /**
     * 
     * @type {number}
     * @memberof RedactedIndividualScoreResponse
     */
    'score': number;
}
/**
 * 
 * @export
 * @interface RelatedStandardEntryResponse
 */
export interface RelatedStandardEntryResponse {
    /**
     * 
     * @type {string}
     * @memberof RelatedStandardEntryResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RelatedStandardEntryResponse
     */
    'std_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RelatedStandardEntryResponse
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RelatedStandardEntryResponse
     */
    'domain'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RelatedStandardEntryResponse
     */
    'domain_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RelatedStandardEntryResponse
     */
    'category'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RelatedStandardEntryResponse
     */
    'category_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RelatedStandardEntryResponse
     */
    'short_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RelatedStandardEntryResponse
     */
    'explanation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RelatedStandardEntryResponse
     */
    'standard'?: string | null;
    /**
     * 
     * @type {Array<any>}
     * @memberof RelatedStandardEntryResponse
     */
    'references'?: Array<any> | null;
    /**
     * 
     * @type {Array<StandardEntryResponse>}
     * @memberof RelatedStandardEntryResponse
     */
    'related_entries'?: Array<StandardEntryResponse>;
}
/**
 * Response model for the user roles endpoint.
 * @export
 * @interface RolesResponseModel
 */
export interface RolesResponseModel {
    /**
     * 
     * @type {Array<string>}
     * @memberof RolesResponseModel
     */
    'roles': Array<string>;
}
/**
 * 
 * @export
 * @interface ScoreCreationResponse
 */
export interface ScoreCreationResponse {
    /**
     * Success or error message
     * @type {string}
     * @memberof ScoreCreationResponse
     */
    'message': string;
    /**
     * The ID of the assessment
     * @type {string}
     * @memberof ScoreCreationResponse
     */
    'assessment_id': string;
    /**
     * The ID of the activity score
     * @type {string}
     * @memberof ScoreCreationResponse
     */
    'activity_score_id': string;
    /**
     * The ID of the activity
     * @type {string}
     * @memberof ScoreCreationResponse
     */
    'activity_id': string;
    /**
     * The standard identifier for the activity
     * @type {string}
     * @memberof ScoreCreationResponse
     */
    'activity': string;
    /**
     * The consensus score of the activity
     * @type {number}
     * @memberof ScoreCreationResponse
     */
    'score': number;
}
/**
 * 
 * @export
 * @interface ScoreResponse
 */
export interface ScoreResponse {
    /**
     * 
     * @type {string}
     * @memberof ScoreResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ScoreResponse
     */
    'assessment_id': string;
    /**
     * 
     * @type {string}
     * @memberof ScoreResponse
     */
    'std_id': string;
    /**
     * 
     * @type {number}
     * @memberof ScoreResponse
     */
    'score': number;
    /**
     * 
     * @type {boolean}
     * @memberof ScoreResponse
     */
    'score_oked': boolean;
}
/**
 * 
 * @export
 * @interface ScoreUpdateRequest
 */
export interface ScoreUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ScoreUpdateRequest
     */
    'assessment_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScoreUpdateRequest
     */
    'activity_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScoreUpdateRequest
     */
    'activity_score_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ScoreUpdateRequest
     */
    'score_value': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ScoreUpdateRequest
     */
    'comment'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ScoreUpdateRequest
     */
    'evidence'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface StandardEntryResponse
 */
export interface StandardEntryResponse {
    /**
     * 
     * @type {string}
     * @memberof StandardEntryResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof StandardEntryResponse
     */
    'std_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StandardEntryResponse
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StandardEntryResponse
     */
    'domain'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StandardEntryResponse
     */
    'domain_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StandardEntryResponse
     */
    'category'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StandardEntryResponse
     */
    'category_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StandardEntryResponse
     */
    'short_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StandardEntryResponse
     */
    'explanation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StandardEntryResponse
     */
    'standard'?: string | null;
    /**
     * 
     * @type {Array<any>}
     * @memberof StandardEntryResponse
     */
    'references'?: Array<any> | null;
}
/**
 * 
 * @export
 * @interface StandardResponse
 */
export interface StandardResponse {
    /**
     * 
     * @type {string}
     * @memberof StandardResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof StandardResponse
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof StandardResponse
     */
    'version': number;
    /**
     * 
     * @type {string}
     * @memberof StandardResponse
     */
    'group'?: string | null;
}
/**
 * 
 * @export
 * @interface Token
 */
export interface Token {
    /**
     * 
     * @type {string}
     * @memberof Token
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Token
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Token
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof Token
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof Token
     */
    'expires_at': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Token
     */
    'roles': Array<string>;
}
/**
 * 
 * @export
 * @interface TokenCreate
 */
export interface TokenCreate {
    /**
     * 
     * @type {string}
     * @memberof TokenCreate
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof TokenCreate
     */
    'expires_in_days'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TokenCreate
     */
    'roles'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface TokenRequest
 */
export interface TokenRequest {
    /**
     * 
     * @type {string}
     * @memberof TokenRequest
     */
    'client_id': string;
    /**
     * 
     * @type {string}
     * @memberof TokenRequest
     */
    'client_secret': string;
    /**
     * 
     * @type {string}
     * @memberof TokenRequest
     */
    'audience': string;
}
/**
 * 
 * @export
 * @interface TokensResponseModel
 */
export interface TokensResponseModel {
    /**
     * 
     * @type {string}
     * @memberof TokensResponseModel
     */
    'id_token': string;
    /**
     * 
     * @type {string}
     * @memberof TokensResponseModel
     */
    'access_token': string;
    /**
     * 
     * @type {string}
     * @memberof TokensResponseModel
     */
    'refresh_token'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TokensResponseModel
     */
    'expires_in': number;
    /**
     * 
     * @type {string}
     * @memberof TokensResponseModel
     */
    'token_type': string;
}
/**
 * 
 * @export
 * @interface UpdateOrganizationRequest
 */
export interface UpdateOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    'domain': string;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<ValidationErrorLocInner>}
     * @memberof ValidationError
     */
    'loc': Array<ValidationErrorLocInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
    /**
     * 
     * @type {any}
     * @memberof ValidationError
     */
    'input'?: any;
    /**
     * 
     * @type {object}
     * @memberof ValidationError
     */
    'ctx'?: object;
}
/**
 * 
 * @export
 * @interface ValidationErrorLocInner
 */
export interface ValidationErrorLocInner {
}

/**
 * AssessmentsApi - axios parameter creator
 * @export
 */
export const AssessmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Adds an existing organization to an assessment.
         * @summary Add Organization To Assessment
         * @param {string} assessmentId 
         * @param {AddOrganizationRequest} addOrganizationRequest 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrganizationToAssessmentApiAssessmentsAssessmentIdAddOrganizationPut: async (assessmentId: string, addOrganizationRequest: AddOrganizationRequest, accessToken?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('addOrganizationToAssessmentApiAssessmentsAssessmentIdAddOrganizationPut', 'assessmentId', assessmentId)
            // verify required parameter 'addOrganizationRequest' is not null or undefined
            assertParamExists('addOrganizationToAssessmentApiAssessmentsAssessmentIdAddOrganizationPut', 'addOrganizationRequest', addOrganizationRequest)
            const localVarPath = `/api/assessments/{assessment_id}/add-organization`
                .replace(`{${"assessment_id"}}`, encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (accessToken != null) {
                localVarHeaderParameter['access-token'] = String(accessToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrganizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add Population Vertical To Assessment
         * @param {string} assessmentId 
         * @param {AddVerticalRequest} addVerticalRequest 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPopulationVerticalToAssessmentApiAssessmentsAssessmentIdAddVerticalPost: async (assessmentId: string, addVerticalRequest: AddVerticalRequest, accessToken?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('addPopulationVerticalToAssessmentApiAssessmentsAssessmentIdAddVerticalPost', 'assessmentId', assessmentId)
            // verify required parameter 'addVerticalRequest' is not null or undefined
            assertParamExists('addPopulationVerticalToAssessmentApiAssessmentsAssessmentIdAddVerticalPost', 'addVerticalRequest', addVerticalRequest)
            const localVarPath = `/api/assessments/{assessment_id}/add-vertical`
                .replace(`{${"assessment_id"}}`, encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (accessToken != null) {
                localVarHeaderParameter['access-token'] = String(accessToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addVerticalRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Convert BSIMM scores from one version to another synchronously. Requires \"read\" permission on the \"assessment\" resource.
         * @summary Convert Assessment Scores
         * @param {string} assessmentId Original Assessment ID
         * @param {ConversionRequest} conversionRequest 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertAssessmentScoresApiConversionAssessmentAssessmentIdPost: async (assessmentId: string, conversionRequest: ConversionRequest, accessToken?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('convertAssessmentScoresApiConversionAssessmentAssessmentIdPost', 'assessmentId', assessmentId)
            // verify required parameter 'conversionRequest' is not null or undefined
            assertParamExists('convertAssessmentScoresApiConversionAssessmentAssessmentIdPost', 'conversionRequest', conversionRequest)
            const localVarPath = `/api/conversion/assessment/{assessment_id}`
                .replace(`{${"assessment_id"}}`, encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (accessToken != null) {
                localVarHeaderParameter['access-token'] = String(accessToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conversionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new assessment. Organization is optional but requires authorization.
         * @summary Create Assessment
         * @param {AssessmentCreate} assessmentCreate 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAssessmentApiAssessmentsPost: async (assessmentCreate: AssessmentCreate, accessToken?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentCreate' is not null or undefined
            assertParamExists('createAssessmentApiAssessmentsPost', 'assessmentCreate', assessmentCreate)
            const localVarPath = `/api/assessments/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (accessToken != null) {
                localVarHeaderParameter['access-token'] = String(accessToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assessmentCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes an assessment by ID if the user has access through assessment ownership, organizational authorization, or admin privileges.
         * @summary Delete Assessment
         * @param {string} assessmentId 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAssessmentApiAssessmentsAssessmentIdDelete: async (assessmentId: string, accessToken?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('deleteAssessmentApiAssessmentsAssessmentIdDelete', 'assessmentId', assessmentId)
            const localVarPath = `/api/assessments/{assessment_id}`
                .replace(`{${"assessment_id"}}`, encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (accessToken != null) {
                localVarHeaderParameter['access-token'] = String(accessToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Assessment
         * @param {string} assessmentId 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessmentApiAssessmentsAssessmentIdGet: async (assessmentId: string, accessToken?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('getAssessmentApiAssessmentsAssessmentIdGet', 'assessmentId', assessmentId)
            const localVarPath = `/api/assessments/{assessment_id}`
                .replace(`{${"assessment_id"}}`, encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (accessToken != null) {
                localVarHeaderParameter['access-token'] = String(accessToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Assessments
         * @param {string | null} [name] 
         * @param {string | null} [standard] 
         * @param {string | null} [organizationId] 
         * @param {boolean | null} [scoresChecked] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {number | null} [page] 
         * @param {number | null} [pageSize] 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessmentsApiAssessmentsGet: async (name?: string | null, standard?: string | null, organizationId?: string | null, scoresChecked?: boolean | null, sortBy?: string, sortOrder?: string, page?: number | null, pageSize?: number | null, accessToken?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/assessments/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (standard !== undefined) {
                localVarQueryParameter['standard'] = standard;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organization_id'] = organizationId;
            }

            if (scoresChecked !== undefined) {
                localVarQueryParameter['scores_checked'] = scoresChecked;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (accessToken != null) {
                localVarHeaderParameter['access-token'] = String(accessToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an assessment by ID with authorization checks.
         * @summary Update Assessment
         * @param {string} assessmentId A valid MongoDB ObjectId
         * @param {AssessmentCreate} assessmentCreate 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAssessmentApiAssessmentsAssessmentIdPut: async (assessmentId: string, assessmentCreate: AssessmentCreate, accessToken?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('updateAssessmentApiAssessmentsAssessmentIdPut', 'assessmentId', assessmentId)
            // verify required parameter 'assessmentCreate' is not null or undefined
            assertParamExists('updateAssessmentApiAssessmentsAssessmentIdPut', 'assessmentCreate', assessmentCreate)
            const localVarPath = `/api/assessments/{assessment_id}`
                .replace(`{${"assessment_id"}}`, encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (accessToken != null) {
                localVarHeaderParameter['access-token'] = String(accessToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assessmentCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssessmentsApi - functional programming interface
 * @export
 */
export const AssessmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssessmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Adds an existing organization to an assessment.
         * @summary Add Organization To Assessment
         * @param {string} assessmentId 
         * @param {AddOrganizationRequest} addOrganizationRequest 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOrganizationToAssessmentApiAssessmentsAssessmentIdAddOrganizationPut(assessmentId: string, addOrganizationRequest: AddOrganizationRequest, accessToken?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOrganizationToAssessmentApiAssessmentsAssessmentIdAddOrganizationPut(assessmentId, addOrganizationRequest, accessToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentsApi.addOrganizationToAssessmentApiAssessmentsAssessmentIdAddOrganizationPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add Population Vertical To Assessment
         * @param {string} assessmentId 
         * @param {AddVerticalRequest} addVerticalRequest 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPopulationVerticalToAssessmentApiAssessmentsAssessmentIdAddVerticalPost(assessmentId: string, addVerticalRequest: AddVerticalRequest, accessToken?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPopulationVerticalToAssessmentApiAssessmentsAssessmentIdAddVerticalPost(assessmentId, addVerticalRequest, accessToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentsApi.addPopulationVerticalToAssessmentApiAssessmentsAssessmentIdAddVerticalPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Convert BSIMM scores from one version to another synchronously. Requires \"read\" permission on the \"assessment\" resource.
         * @summary Convert Assessment Scores
         * @param {string} assessmentId Original Assessment ID
         * @param {ConversionRequest} conversionRequest 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async convertAssessmentScoresApiConversionAssessmentAssessmentIdPost(assessmentId: string, conversionRequest: ConversionRequest, accessToken?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.convertAssessmentScoresApiConversionAssessmentAssessmentIdPost(assessmentId, conversionRequest, accessToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentsApi.convertAssessmentScoresApiConversionAssessmentAssessmentIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new assessment. Organization is optional but requires authorization.
         * @summary Create Assessment
         * @param {AssessmentCreate} assessmentCreate 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAssessmentApiAssessmentsPost(assessmentCreate: AssessmentCreate, accessToken?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAssessmentApiAssessmentsPost(assessmentCreate, accessToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentsApi.createAssessmentApiAssessmentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes an assessment by ID if the user has access through assessment ownership, organizational authorization, or admin privileges.
         * @summary Delete Assessment
         * @param {string} assessmentId 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAssessmentApiAssessmentsAssessmentIdDelete(assessmentId: string, accessToken?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAssessmentApiAssessmentsAssessmentIdDelete(assessmentId, accessToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentsApi.deleteAssessmentApiAssessmentsAssessmentIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Assessment
         * @param {string} assessmentId 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssessmentApiAssessmentsAssessmentIdGet(assessmentId: string, accessToken?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssessmentApiAssessmentsAssessmentIdGet(assessmentId, accessToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentsApi.getAssessmentApiAssessmentsAssessmentIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Assessments
         * @param {string | null} [name] 
         * @param {string | null} [standard] 
         * @param {string | null} [organizationId] 
         * @param {boolean | null} [scoresChecked] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {number | null} [page] 
         * @param {number | null} [pageSize] 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssessmentsApiAssessmentsGet(name?: string | null, standard?: string | null, organizationId?: string | null, scoresChecked?: boolean | null, sortBy?: string, sortOrder?: string, page?: number | null, pageSize?: number | null, accessToken?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseAssessmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssessmentsApiAssessmentsGet(name, standard, organizationId, scoresChecked, sortBy, sortOrder, page, pageSize, accessToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentsApi.getAssessmentsApiAssessmentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an assessment by ID with authorization checks.
         * @summary Update Assessment
         * @param {string} assessmentId A valid MongoDB ObjectId
         * @param {AssessmentCreate} assessmentCreate 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAssessmentApiAssessmentsAssessmentIdPut(assessmentId: string, assessmentCreate: AssessmentCreate, accessToken?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAssessmentApiAssessmentsAssessmentIdPut(assessmentId, assessmentCreate, accessToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentsApi.updateAssessmentApiAssessmentsAssessmentIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssessmentsApi - factory interface
 * @export
 */
export const AssessmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssessmentsApiFp(configuration)
    return {
        /**
         * Adds an existing organization to an assessment.
         * @summary Add Organization To Assessment
         * @param {string} assessmentId 
         * @param {AddOrganizationRequest} addOrganizationRequest 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrganizationToAssessmentApiAssessmentsAssessmentIdAddOrganizationPut(assessmentId: string, addOrganizationRequest: AddOrganizationRequest, accessToken?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.addOrganizationToAssessmentApiAssessmentsAssessmentIdAddOrganizationPut(assessmentId, addOrganizationRequest, accessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add Population Vertical To Assessment
         * @param {string} assessmentId 
         * @param {AddVerticalRequest} addVerticalRequest 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPopulationVerticalToAssessmentApiAssessmentsAssessmentIdAddVerticalPost(assessmentId: string, addVerticalRequest: AddVerticalRequest, accessToken?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.addPopulationVerticalToAssessmentApiAssessmentsAssessmentIdAddVerticalPost(assessmentId, addVerticalRequest, accessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Convert BSIMM scores from one version to another synchronously. Requires \"read\" permission on the \"assessment\" resource.
         * @summary Convert Assessment Scores
         * @param {string} assessmentId Original Assessment ID
         * @param {ConversionRequest} conversionRequest 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertAssessmentScoresApiConversionAssessmentAssessmentIdPost(assessmentId: string, conversionRequest: ConversionRequest, accessToken?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.convertAssessmentScoresApiConversionAssessmentAssessmentIdPost(assessmentId, conversionRequest, accessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new assessment. Organization is optional but requires authorization.
         * @summary Create Assessment
         * @param {AssessmentCreate} assessmentCreate 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAssessmentApiAssessmentsPost(assessmentCreate: AssessmentCreate, accessToken?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<AssessmentResponse> {
            return localVarFp.createAssessmentApiAssessmentsPost(assessmentCreate, accessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes an assessment by ID if the user has access through assessment ownership, organizational authorization, or admin privileges.
         * @summary Delete Assessment
         * @param {string} assessmentId 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAssessmentApiAssessmentsAssessmentIdDelete(assessmentId: string, accessToken?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteAssessmentApiAssessmentsAssessmentIdDelete(assessmentId, accessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Assessment
         * @param {string} assessmentId 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessmentApiAssessmentsAssessmentIdGet(assessmentId: string, accessToken?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<AssessmentResponse> {
            return localVarFp.getAssessmentApiAssessmentsAssessmentIdGet(assessmentId, accessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Assessments
         * @param {string | null} [name] 
         * @param {string | null} [standard] 
         * @param {string | null} [organizationId] 
         * @param {boolean | null} [scoresChecked] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {number | null} [page] 
         * @param {number | null} [pageSize] 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssessmentsApiAssessmentsGet(name?: string | null, standard?: string | null, organizationId?: string | null, scoresChecked?: boolean | null, sortBy?: string, sortOrder?: string, page?: number | null, pageSize?: number | null, accessToken?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseAssessmentResponse> {
            return localVarFp.getAssessmentsApiAssessmentsGet(name, standard, organizationId, scoresChecked, sortBy, sortOrder, page, pageSize, accessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an assessment by ID with authorization checks.
         * @summary Update Assessment
         * @param {string} assessmentId A valid MongoDB ObjectId
         * @param {AssessmentCreate} assessmentCreate 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAssessmentApiAssessmentsAssessmentIdPut(assessmentId: string, assessmentCreate: AssessmentCreate, accessToken?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<AssessmentResponse> {
            return localVarFp.updateAssessmentApiAssessmentsAssessmentIdPut(assessmentId, assessmentCreate, accessToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AssessmentsApi - object-oriented interface
 * @export
 * @class AssessmentsApi
 * @extends {BaseAPI}
 */
export class AssessmentsApi extends BaseAPI {
    /**
     * Adds an existing organization to an assessment.
     * @summary Add Organization To Assessment
     * @param {string} assessmentId 
     * @param {AddOrganizationRequest} addOrganizationRequest 
     * @param {string | null} [accessToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentsApi
     */
    public addOrganizationToAssessmentApiAssessmentsAssessmentIdAddOrganizationPut(assessmentId: string, addOrganizationRequest: AddOrganizationRequest, accessToken?: string | null, options?: RawAxiosRequestConfig) {
        return AssessmentsApiFp(this.configuration).addOrganizationToAssessmentApiAssessmentsAssessmentIdAddOrganizationPut(assessmentId, addOrganizationRequest, accessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add Population Vertical To Assessment
     * @param {string} assessmentId 
     * @param {AddVerticalRequest} addVerticalRequest 
     * @param {string | null} [accessToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentsApi
     */
    public addPopulationVerticalToAssessmentApiAssessmentsAssessmentIdAddVerticalPost(assessmentId: string, addVerticalRequest: AddVerticalRequest, accessToken?: string | null, options?: RawAxiosRequestConfig) {
        return AssessmentsApiFp(this.configuration).addPopulationVerticalToAssessmentApiAssessmentsAssessmentIdAddVerticalPost(assessmentId, addVerticalRequest, accessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Convert BSIMM scores from one version to another synchronously. Requires \"read\" permission on the \"assessment\" resource.
     * @summary Convert Assessment Scores
     * @param {string} assessmentId Original Assessment ID
     * @param {ConversionRequest} conversionRequest 
     * @param {string | null} [accessToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentsApi
     */
    public convertAssessmentScoresApiConversionAssessmentAssessmentIdPost(assessmentId: string, conversionRequest: ConversionRequest, accessToken?: string | null, options?: RawAxiosRequestConfig) {
        return AssessmentsApiFp(this.configuration).convertAssessmentScoresApiConversionAssessmentAssessmentIdPost(assessmentId, conversionRequest, accessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new assessment. Organization is optional but requires authorization.
     * @summary Create Assessment
     * @param {AssessmentCreate} assessmentCreate 
     * @param {string | null} [accessToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentsApi
     */
    public createAssessmentApiAssessmentsPost(assessmentCreate: AssessmentCreate, accessToken?: string | null, options?: RawAxiosRequestConfig) {
        return AssessmentsApiFp(this.configuration).createAssessmentApiAssessmentsPost(assessmentCreate, accessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes an assessment by ID if the user has access through assessment ownership, organizational authorization, or admin privileges.
     * @summary Delete Assessment
     * @param {string} assessmentId 
     * @param {string | null} [accessToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentsApi
     */
    public deleteAssessmentApiAssessmentsAssessmentIdDelete(assessmentId: string, accessToken?: string | null, options?: RawAxiosRequestConfig) {
        return AssessmentsApiFp(this.configuration).deleteAssessmentApiAssessmentsAssessmentIdDelete(assessmentId, accessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Assessment
     * @param {string} assessmentId 
     * @param {string | null} [accessToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentsApi
     */
    public getAssessmentApiAssessmentsAssessmentIdGet(assessmentId: string, accessToken?: string | null, options?: RawAxiosRequestConfig) {
        return AssessmentsApiFp(this.configuration).getAssessmentApiAssessmentsAssessmentIdGet(assessmentId, accessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Assessments
     * @param {string | null} [name] 
     * @param {string | null} [standard] 
     * @param {string | null} [organizationId] 
     * @param {boolean | null} [scoresChecked] 
     * @param {string} [sortBy] 
     * @param {string} [sortOrder] 
     * @param {number | null} [page] 
     * @param {number | null} [pageSize] 
     * @param {string | null} [accessToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentsApi
     */
    public getAssessmentsApiAssessmentsGet(name?: string | null, standard?: string | null, organizationId?: string | null, scoresChecked?: boolean | null, sortBy?: string, sortOrder?: string, page?: number | null, pageSize?: number | null, accessToken?: string | null, options?: RawAxiosRequestConfig) {
        return AssessmentsApiFp(this.configuration).getAssessmentsApiAssessmentsGet(name, standard, organizationId, scoresChecked, sortBy, sortOrder, page, pageSize, accessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an assessment by ID with authorization checks.
     * @summary Update Assessment
     * @param {string} assessmentId A valid MongoDB ObjectId
     * @param {AssessmentCreate} assessmentCreate 
     * @param {string | null} [accessToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentsApi
     */
    public updateAssessmentApiAssessmentsAssessmentIdPut(assessmentId: string, assessmentCreate: AssessmentCreate, accessToken?: string | null, options?: RawAxiosRequestConfig) {
        return AssessmentsApiFp(this.configuration).updateAssessmentApiAssessmentsAssessmentIdPut(assessmentId, assessmentCreate, accessToken, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Callback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackApiAuthCallbackGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/callback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to exchange an authorization code for tokens from Auth0.  Args:     code (str): The authorization code received from Auth0.     redirect_uri (str): The redirect URI used during login.  Returns:     TokensResponseModel: The tokens received from Auth0.
         * @summary Exchange Tokens
         * @param {string} code Authorization code from Auth0
         * @param {string | null} [redirectUri] Redirect URI used during login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeTokensApiAuthExchangeTokensGet: async (code: string, redirectUri?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('exchangeTokensApiAuthExchangeTokensGet', 'code', code)
            const localVarPath = `/api/auth/exchange-tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (redirectUri !== undefined) {
                localVarQueryParameter['redirect_uri'] = redirectUri;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Redirect user to Auth0 for authentication.  Args:     request: The incoming HTTP request.  Returns:     RedirectResponse: Redirects the user to Auth0\'s authorization URL.
         * @summary Login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginApiAuthLoginGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutApiAuthLogoutGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to generate a JWT for service accounts.  Args:     request (TokenRequest): The token request containing client_id and client_secret.     expires_in (int): Optional. Expiry time for the token in seconds.  Returns:     AccessTokenResponse: A JWT token and metadata.
         * @summary Oauth Service Token
         * @param {TokenRequest} tokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauthServiceTokenApiAuthOauthServiceTokenPost: async (tokenRequest: TokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenRequest' is not null or undefined
            assertParamExists('oauthServiceTokenApiAuthOauthServiceTokenPost', 'tokenRequest', tokenRequest)
            const localVarPath = `/api/auth/oauth/service-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authenticate client credentials and generate a JWT access token.  Args:     client_id (str): The client ID of the user/service account.     client_secret (str): The client secret associated with the client ID.     expires_in (int): Optional. Expiry time for the token in seconds. Defaults to `JWT_EXPIRY_SECONDS`.  Returns:     dict: A dictionary containing the JWT access token and metadata.
         * @summary Oauth Token
         * @param {TokenRequest} tokenRequest 
         * @param {number} [expiresIn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauthTokenApiAuthOauthTokenPost: async (tokenRequest: TokenRequest, expiresIn?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenRequest' is not null or undefined
            assertParamExists('oauthTokenApiAuthOauthTokenPost', 'tokenRequest', tokenRequest)
            const localVarPath = `/api/auth/oauth/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (expiresIn !== undefined) {
                localVarQueryParameter['expires_in'] = expiresIn;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to refresh access tokens using a refresh token. The refresh token is expected to be in a secure, HTTP-only cookie.
         * @summary Refresh Tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshTokensApiAuthRefreshPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Extract and return user roles from the provided access or refresh token.  The endpoint accepts tokens from: - Authorization header (Bearer token) - access_token cookie - id_token cookie - refresh_token cookie  Returns:     RolesResponseModel: A JSON object with a list of roles.
         * @summary Refresh Tokens
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshTokensApiAuthRolesGet: async (accessToken?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accessToken != null) {
                localVarHeaderParameter['access-token'] = String(accessToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate Enrollable
         * @param {EnrollRequest} enrollRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateEnrollableApiAuthValidateEnrollablePost: async (enrollRequest: EnrollRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'enrollRequest' is not null or undefined
            assertParamExists('validateEnrollableApiAuthValidateEnrollablePost', 'enrollRequest', enrollRequest)
            const localVarPath = `/api/auth/validate-enrollable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(enrollRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Callback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async callbackApiAuthCallbackGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.callbackApiAuthCallbackGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.callbackApiAuthCallbackGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Endpoint to exchange an authorization code for tokens from Auth0.  Args:     code (str): The authorization code received from Auth0.     redirect_uri (str): The redirect URI used during login.  Returns:     TokensResponseModel: The tokens received from Auth0.
         * @summary Exchange Tokens
         * @param {string} code Authorization code from Auth0
         * @param {string | null} [redirectUri] Redirect URI used during login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exchangeTokensApiAuthExchangeTokensGet(code: string, redirectUri?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokensResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exchangeTokensApiAuthExchangeTokensGet(code, redirectUri, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.exchangeTokensApiAuthExchangeTokensGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Redirect user to Auth0 for authentication.  Args:     request: The incoming HTTP request.  Returns:     RedirectResponse: Redirects the user to Auth0\'s authorization URL.
         * @summary Login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginApiAuthLoginGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginApiAuthLoginGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.loginApiAuthLoginGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logoutApiAuthLogoutGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logoutApiAuthLogoutGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.logoutApiAuthLogoutGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Endpoint to generate a JWT for service accounts.  Args:     request (TokenRequest): The token request containing client_id and client_secret.     expires_in (int): Optional. Expiry time for the token in seconds.  Returns:     AccessTokenResponse: A JWT token and metadata.
         * @summary Oauth Service Token
         * @param {TokenRequest} tokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async oauthServiceTokenApiAuthOauthServiceTokenPost(tokenRequest: TokenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.oauthServiceTokenApiAuthOauthServiceTokenPost(tokenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.oauthServiceTokenApiAuthOauthServiceTokenPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authenticate client credentials and generate a JWT access token.  Args:     client_id (str): The client ID of the user/service account.     client_secret (str): The client secret associated with the client ID.     expires_in (int): Optional. Expiry time for the token in seconds. Defaults to `JWT_EXPIRY_SECONDS`.  Returns:     dict: A dictionary containing the JWT access token and metadata.
         * @summary Oauth Token
         * @param {TokenRequest} tokenRequest 
         * @param {number} [expiresIn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async oauthTokenApiAuthOauthTokenPost(tokenRequest: TokenRequest, expiresIn?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.oauthTokenApiAuthOauthTokenPost(tokenRequest, expiresIn, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.oauthTokenApiAuthOauthTokenPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Endpoint to refresh access tokens using a refresh token. The refresh token is expected to be in a secure, HTTP-only cookie.
         * @summary Refresh Tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshTokensApiAuthRefreshPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokensResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshTokensApiAuthRefreshPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.refreshTokensApiAuthRefreshPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Extract and return user roles from the provided access or refresh token.  The endpoint accepts tokens from: - Authorization header (Bearer token) - access_token cookie - id_token cookie - refresh_token cookie  Returns:     RolesResponseModel: A JSON object with a list of roles.
         * @summary Refresh Tokens
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshTokensApiAuthRolesGet(accessToken?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RolesResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshTokensApiAuthRolesGet(accessToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.refreshTokensApiAuthRolesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Validate Enrollable
         * @param {EnrollRequest} enrollRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateEnrollableApiAuthValidateEnrollablePost(enrollRequest: EnrollRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateEnrollableApiAuthValidateEnrollablePost(enrollRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.validateEnrollableApiAuthValidateEnrollablePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 
         * @summary Callback
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callbackApiAuthCallbackGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.callbackApiAuthCallbackGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to exchange an authorization code for tokens from Auth0.  Args:     code (str): The authorization code received from Auth0.     redirect_uri (str): The redirect URI used during login.  Returns:     TokensResponseModel: The tokens received from Auth0.
         * @summary Exchange Tokens
         * @param {string} code Authorization code from Auth0
         * @param {string | null} [redirectUri] Redirect URI used during login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeTokensApiAuthExchangeTokensGet(code: string, redirectUri?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<TokensResponseModel> {
            return localVarFp.exchangeTokensApiAuthExchangeTokensGet(code, redirectUri, options).then((request) => request(axios, basePath));
        },
        /**
         * Redirect user to Auth0 for authentication.  Args:     request: The incoming HTTP request.  Returns:     RedirectResponse: Redirects the user to Auth0\'s authorization URL.
         * @summary Login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginApiAuthLoginGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.loginApiAuthLoginGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutApiAuthLogoutGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.logoutApiAuthLogoutGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to generate a JWT for service accounts.  Args:     request (TokenRequest): The token request containing client_id and client_secret.     expires_in (int): Optional. Expiry time for the token in seconds.  Returns:     AccessTokenResponse: A JWT token and metadata.
         * @summary Oauth Service Token
         * @param {TokenRequest} tokenRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauthServiceTokenApiAuthOauthServiceTokenPost(tokenRequest: TokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<AccessTokenResponse> {
            return localVarFp.oauthServiceTokenApiAuthOauthServiceTokenPost(tokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Authenticate client credentials and generate a JWT access token.  Args:     client_id (str): The client ID of the user/service account.     client_secret (str): The client secret associated with the client ID.     expires_in (int): Optional. Expiry time for the token in seconds. Defaults to `JWT_EXPIRY_SECONDS`.  Returns:     dict: A dictionary containing the JWT access token and metadata.
         * @summary Oauth Token
         * @param {TokenRequest} tokenRequest 
         * @param {number} [expiresIn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauthTokenApiAuthOauthTokenPost(tokenRequest: TokenRequest, expiresIn?: number, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.oauthTokenApiAuthOauthTokenPost(tokenRequest, expiresIn, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to refresh access tokens using a refresh token. The refresh token is expected to be in a secure, HTTP-only cookie.
         * @summary Refresh Tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshTokensApiAuthRefreshPost(options?: RawAxiosRequestConfig): AxiosPromise<TokensResponseModel> {
            return localVarFp.refreshTokensApiAuthRefreshPost(options).then((request) => request(axios, basePath));
        },
        /**
         * Extract and return user roles from the provided access or refresh token.  The endpoint accepts tokens from: - Authorization header (Bearer token) - access_token cookie - id_token cookie - refresh_token cookie  Returns:     RolesResponseModel: A JSON object with a list of roles.
         * @summary Refresh Tokens
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshTokensApiAuthRolesGet(accessToken?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<RolesResponseModel> {
            return localVarFp.refreshTokensApiAuthRolesGet(accessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate Enrollable
         * @param {EnrollRequest} enrollRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateEnrollableApiAuthValidateEnrollablePost(enrollRequest: EnrollRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.validateEnrollableApiAuthValidateEnrollablePost(enrollRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * 
     * @summary Callback
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public callbackApiAuthCallbackGet(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).callbackApiAuthCallbackGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to exchange an authorization code for tokens from Auth0.  Args:     code (str): The authorization code received from Auth0.     redirect_uri (str): The redirect URI used during login.  Returns:     TokensResponseModel: The tokens received from Auth0.
     * @summary Exchange Tokens
     * @param {string} code Authorization code from Auth0
     * @param {string | null} [redirectUri] Redirect URI used during login
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public exchangeTokensApiAuthExchangeTokensGet(code: string, redirectUri?: string | null, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).exchangeTokensApiAuthExchangeTokensGet(code, redirectUri, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Redirect user to Auth0 for authentication.  Args:     request: The incoming HTTP request.  Returns:     RedirectResponse: Redirects the user to Auth0\'s authorization URL.
     * @summary Login
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public loginApiAuthLoginGet(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).loginApiAuthLoginGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public logoutApiAuthLogoutGet(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).logoutApiAuthLogoutGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to generate a JWT for service accounts.  Args:     request (TokenRequest): The token request containing client_id and client_secret.     expires_in (int): Optional. Expiry time for the token in seconds.  Returns:     AccessTokenResponse: A JWT token and metadata.
     * @summary Oauth Service Token
     * @param {TokenRequest} tokenRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public oauthServiceTokenApiAuthOauthServiceTokenPost(tokenRequest: TokenRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).oauthServiceTokenApiAuthOauthServiceTokenPost(tokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Authenticate client credentials and generate a JWT access token.  Args:     client_id (str): The client ID of the user/service account.     client_secret (str): The client secret associated with the client ID.     expires_in (int): Optional. Expiry time for the token in seconds. Defaults to `JWT_EXPIRY_SECONDS`.  Returns:     dict: A dictionary containing the JWT access token and metadata.
     * @summary Oauth Token
     * @param {TokenRequest} tokenRequest 
     * @param {number} [expiresIn] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public oauthTokenApiAuthOauthTokenPost(tokenRequest: TokenRequest, expiresIn?: number, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).oauthTokenApiAuthOauthTokenPost(tokenRequest, expiresIn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to refresh access tokens using a refresh token. The refresh token is expected to be in a secure, HTTP-only cookie.
     * @summary Refresh Tokens
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public refreshTokensApiAuthRefreshPost(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).refreshTokensApiAuthRefreshPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Extract and return user roles from the provided access or refresh token.  The endpoint accepts tokens from: - Authorization header (Bearer token) - access_token cookie - id_token cookie - refresh_token cookie  Returns:     RolesResponseModel: A JSON object with a list of roles.
     * @summary Refresh Tokens
     * @param {string | null} [accessToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public refreshTokensApiAuthRolesGet(accessToken?: string | null, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).refreshTokensApiAuthRolesGet(accessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate Enrollable
     * @param {EnrollRequest} enrollRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public validateEnrollableApiAuthValidateEnrollablePost(enrollRequest: EnrollRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).validateEnrollableApiAuthValidateEnrollablePost(enrollRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ConvertApi - axios parameter creator
 * @export
 */
export const ConvertApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Convert BSIMM scores from one version to another synchronously. Requires \"read\" permission on the \"assessment\" resource.
         * @summary Convert Assessment Scores
         * @param {string} assessmentId Original Assessment ID
         * @param {ConversionRequest} conversionRequest 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertAssessmentScoresApiConversionAssessmentAssessmentIdPost: async (assessmentId: string, conversionRequest: ConversionRequest, accessToken?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('convertAssessmentScoresApiConversionAssessmentAssessmentIdPost', 'assessmentId', assessmentId)
            // verify required parameter 'conversionRequest' is not null or undefined
            assertParamExists('convertAssessmentScoresApiConversionAssessmentAssessmentIdPost', 'conversionRequest', conversionRequest)
            const localVarPath = `/api/conversion/assessment/{assessment_id}`
                .replace(`{${"assessment_id"}}`, encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (accessToken != null) {
                localVarHeaderParameter['access-token'] = String(accessToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(conversionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConvertApi - functional programming interface
 * @export
 */
export const ConvertApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConvertApiAxiosParamCreator(configuration)
    return {
        /**
         * Convert BSIMM scores from one version to another synchronously. Requires \"read\" permission on the \"assessment\" resource.
         * @summary Convert Assessment Scores
         * @param {string} assessmentId Original Assessment ID
         * @param {ConversionRequest} conversionRequest 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async convertAssessmentScoresApiConversionAssessmentAssessmentIdPost(assessmentId: string, conversionRequest: ConversionRequest, accessToken?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.convertAssessmentScoresApiConversionAssessmentAssessmentIdPost(assessmentId, conversionRequest, accessToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConvertApi.convertAssessmentScoresApiConversionAssessmentAssessmentIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ConvertApi - factory interface
 * @export
 */
export const ConvertApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConvertApiFp(configuration)
    return {
        /**
         * Convert BSIMM scores from one version to another synchronously. Requires \"read\" permission on the \"assessment\" resource.
         * @summary Convert Assessment Scores
         * @param {string} assessmentId Original Assessment ID
         * @param {ConversionRequest} conversionRequest 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertAssessmentScoresApiConversionAssessmentAssessmentIdPost(assessmentId: string, conversionRequest: ConversionRequest, accessToken?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.convertAssessmentScoresApiConversionAssessmentAssessmentIdPost(assessmentId, conversionRequest, accessToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConvertApi - object-oriented interface
 * @export
 * @class ConvertApi
 * @extends {BaseAPI}
 */
export class ConvertApi extends BaseAPI {
    /**
     * Convert BSIMM scores from one version to another synchronously. Requires \"read\" permission on the \"assessment\" resource.
     * @summary Convert Assessment Scores
     * @param {string} assessmentId Original Assessment ID
     * @param {ConversionRequest} conversionRequest 
     * @param {string | null} [accessToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConvertApi
     */
    public convertAssessmentScoresApiConversionAssessmentAssessmentIdPost(assessmentId: string, conversionRequest: ConversionRequest, accessToken?: string | null, options?: RawAxiosRequestConfig) {
        return ConvertApiFp(this.configuration).convertAssessmentScoresApiConversionAssessmentAssessmentIdPost(assessmentId, conversionRequest, accessToken, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Healthz
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthzApiHealthzGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/healthz`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Metrics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metricsApiMetricsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/metrics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Openapi Spec
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiSpecApiOpenapiJsonGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/openapi.json`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read Api Root
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readApiRootApiGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read Api Root
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readApiRootApiGet_1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read Root
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readRootGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Redoc Html
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redocHtmlApiRedocHtmlGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/redoc.html`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Healthz
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthzApiHealthzGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthzApiHealthzGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.healthzApiHealthzGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Metrics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metricsApiMetricsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metricsApiMetricsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.metricsApiMetricsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Openapi Spec
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openapiSpecApiOpenapiJsonGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openapiSpecApiOpenapiJsonGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.openapiSpecApiOpenapiJsonGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read Api Root
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readApiRootApiGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readApiRootApiGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.readApiRootApiGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read Api Root
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readApiRootApiGet_1(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readApiRootApiGet_1(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.readApiRootApiGet_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read Root
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readRootGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readRootGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.readRootGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Redoc Html
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redocHtmlApiRedocHtmlGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redocHtmlApiRedocHtmlGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.redocHtmlApiRedocHtmlGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @summary Healthz
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthzApiHealthzGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.healthzApiHealthzGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Metrics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metricsApiMetricsGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.metricsApiMetricsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Openapi Spec
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openapiSpecApiOpenapiJsonGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.openapiSpecApiOpenapiJsonGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read Api Root
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readApiRootApiGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.readApiRootApiGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read Api Root
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readApiRootApiGet_1(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.readApiRootApiGet_1(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read Root
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readRootGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.readRootGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Redoc Html
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redocHtmlApiRedocHtmlGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.redocHtmlApiRedocHtmlGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @summary Healthz
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public healthzApiHealthzGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).healthzApiHealthzGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Metrics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public metricsApiMetricsGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).metricsApiMetricsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Openapi Spec
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public openapiSpecApiOpenapiJsonGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).openapiSpecApiOpenapiJsonGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read Api Root
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public readApiRootApiGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).readApiRootApiGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read Api Root
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public readApiRootApiGet_1(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).readApiRootApiGet_1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read Root
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public readRootGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).readRootGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Redoc Html
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public redocHtmlApiRedocHtmlGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).redocHtmlApiRedocHtmlGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FileUploadApi - axios parameter creator
 * @export
 */
export const FileUploadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Endpoint to download assessment scores for a given assessment ID.
         * @summary Download Assessment Scores View
         * @param {string} assessmentId 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAssessmentScoresViewApiFileAssessmentScoresDownloadAssessmentIdGet: async (assessmentId: string, accessToken?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('downloadAssessmentScoresViewApiFileAssessmentScoresDownloadAssessmentIdGet', 'assessmentId', assessmentId)
            const localVarPath = `/api/file/assessment-scores/download/{assessment_id}`
                .replace(`{${"assessment_id"}}`, encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (accessToken != null) {
                localVarHeaderParameter['access-token'] = String(accessToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint for file upload with assessment and standard details.
         * @summary File Upload Api
         * @param {string} file 
         * @param {string | null} [standardName] 
         * @param {string | null} [version] 
         * @param {string | null} [assessmentId] 
         * @param {string | null} [standardId] 
         * @param {string | null} [newAssessmentName] 
         * @param {string | null} [groupScoreOverride] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUploadApiApiFileAssessmentUploadPost: async (file: string, standardName?: string | null, version?: string | null, assessmentId?: string | null, standardId?: string | null, newAssessmentName?: string | null, groupScoreOverride?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('fileUploadApiApiFileAssessmentUploadPost', 'file', file)
            const localVarPath = `/api/file/assessment/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (standardName !== undefined) { 
                localVarFormParams.append('standard_name', standardName as any);
            }
    
            if (version !== undefined) { 
                localVarFormParams.append('version', version as any);
            }
    
            if (assessmentId !== undefined) { 
                localVarFormParams.append('assessment_id', assessmentId as any);
            }
    
            if (standardId !== undefined) { 
                localVarFormParams.append('standard_id', standardId as any);
            }
    
            if (newAssessmentName !== undefined) { 
                localVarFormParams.append('new_assessment_name', newAssessmentName as any);
            }
    
            if (groupScoreOverride !== undefined) { 
                localVarFormParams.append('group_score_override', groupScoreOverride as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Render file upload form with standard and assessment options.
         * @summary File Upload Form
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUploadFormApiFileAssessmentUploadFormGet: async (accessToken?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/file/assessment/upload/form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (accessToken != null) {
                localVarHeaderParameter['access-token'] = String(accessToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to download file from MinIO storage.
         * @summary Minio File Download View
         * @param {string} filePath 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        minioFileDownloadViewApiFileDownloadGet: async (filePath: string, accessToken?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filePath' is not null or undefined
            assertParamExists('minioFileDownloadViewApiFileDownloadGet', 'filePath', filePath)
            const localVarPath = `/api/file/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OptionalHTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filePath !== undefined) {
                localVarQueryParameter['file_path'] = filePath;
            }

            if (accessToken != null) {
                localVarHeaderParameter['access-token'] = String(accessToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handle file upload from form submission.
         * @summary Submit File Upload Form
         * @param {string} file 
         * @param {string | null} [standardId] 
         * @param {string | null} [assessmentId] 
         * @param {string | null} [newAssessmentName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFileUploadFormApiFileAssessmentUploadFormPost: async (file: string, standardId?: string | null, assessmentId?: string | null, newAssessmentName?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('submitFileUploadFormApiFileAssessmentUploadFormPost', 'file', file)
            const localVarPath = `/api/file/assessment/upload/form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (standardId !== undefined) { 
                localVarFormParams.append('standard_id', standardId as any);
            }
    
            if (assessmentId !== undefined) { 
                localVarFormParams.append('assessment_id', assessmentId as any);
            }
    
            if (newAssessmentName !== undefined) { 
                localVarFormParams.append('new_assessment_name', newAssessmentName as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileUploadApi - functional programming interface
 * @export
 */
export const FileUploadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FileUploadApiAxiosParamCreator(configuration)
    return {
        /**
         * Endpoint to download assessment scores for a given assessment ID.
         * @summary Download Assessment Scores View
         * @param {string} assessmentId 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadAssessmentScoresViewApiFileAssessmentScoresDownloadAssessmentIdGet(assessmentId: string, accessToken?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAssessmentScoresViewApiFileAssessmentScoresDownloadAssessmentIdGet(assessmentId, accessToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUploadApi.downloadAssessmentScoresViewApiFileAssessmentScoresDownloadAssessmentIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * API endpoint for file upload with assessment and standard details.
         * @summary File Upload Api
         * @param {string} file 
         * @param {string | null} [standardName] 
         * @param {string | null} [version] 
         * @param {string | null} [assessmentId] 
         * @param {string | null} [standardId] 
         * @param {string | null} [newAssessmentName] 
         * @param {string | null} [groupScoreOverride] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUploadApiApiFileAssessmentUploadPost(file: string, standardName?: string | null, version?: string | null, assessmentId?: string | null, standardId?: string | null, newAssessmentName?: string | null, groupScoreOverride?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUploadApiApiFileAssessmentUploadPost(file, standardName, version, assessmentId, standardId, newAssessmentName, groupScoreOverride, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUploadApi.fileUploadApiApiFileAssessmentUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Render file upload form with standard and assessment options.
         * @summary File Upload Form
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUploadFormApiFileAssessmentUploadFormGet(accessToken?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUploadFormApiFileAssessmentUploadFormGet(accessToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUploadApi.fileUploadFormApiFileAssessmentUploadFormGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Endpoint to download file from MinIO storage.
         * @summary Minio File Download View
         * @param {string} filePath 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async minioFileDownloadViewApiFileDownloadGet(filePath: string, accessToken?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.minioFileDownloadViewApiFileDownloadGet(filePath, accessToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUploadApi.minioFileDownloadViewApiFileDownloadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handle file upload from form submission.
         * @summary Submit File Upload Form
         * @param {string} file 
         * @param {string | null} [standardId] 
         * @param {string | null} [assessmentId] 
         * @param {string | null} [newAssessmentName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitFileUploadFormApiFileAssessmentUploadFormPost(file: string, standardId?: string | null, assessmentId?: string | null, newAssessmentName?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitFileUploadFormApiFileAssessmentUploadFormPost(file, standardId, assessmentId, newAssessmentName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUploadApi.submitFileUploadFormApiFileAssessmentUploadFormPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FileUploadApi - factory interface
 * @export
 */
export const FileUploadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FileUploadApiFp(configuration)
    return {
        /**
         * Endpoint to download assessment scores for a given assessment ID.
         * @summary Download Assessment Scores View
         * @param {string} assessmentId 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAssessmentScoresViewApiFileAssessmentScoresDownloadAssessmentIdGet(assessmentId: string, accessToken?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.downloadAssessmentScoresViewApiFileAssessmentScoresDownloadAssessmentIdGet(assessmentId, accessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint for file upload with assessment and standard details.
         * @summary File Upload Api
         * @param {string} file 
         * @param {string | null} [standardName] 
         * @param {string | null} [version] 
         * @param {string | null} [assessmentId] 
         * @param {string | null} [standardId] 
         * @param {string | null} [newAssessmentName] 
         * @param {string | null} [groupScoreOverride] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUploadApiApiFileAssessmentUploadPost(file: string, standardName?: string | null, version?: string | null, assessmentId?: string | null, standardId?: string | null, newAssessmentName?: string | null, groupScoreOverride?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.fileUploadApiApiFileAssessmentUploadPost(file, standardName, version, assessmentId, standardId, newAssessmentName, groupScoreOverride, options).then((request) => request(axios, basePath));
        },
        /**
         * Render file upload form with standard and assessment options.
         * @summary File Upload Form
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUploadFormApiFileAssessmentUploadFormGet(accessToken?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.fileUploadFormApiFileAssessmentUploadFormGet(accessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to download file from MinIO storage.
         * @summary Minio File Download View
         * @param {string} filePath 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        minioFileDownloadViewApiFileDownloadGet(filePath: string, accessToken?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.minioFileDownloadViewApiFileDownloadGet(filePath, accessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Handle file upload from form submission.
         * @summary Submit File Upload Form
         * @param {string} file 
         * @param {string | null} [standardId] 
         * @param {string | null} [assessmentId] 
         * @param {string | null} [newAssessmentName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFileUploadFormApiFileAssessmentUploadFormPost(file: string, standardId?: string | null, assessmentId?: string | null, newAssessmentName?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.submitFileUploadFormApiFileAssessmentUploadFormPost(file, standardId, assessmentId, newAssessmentName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FileUploadApi - object-oriented interface
 * @export
 * @class FileUploadApi
 * @extends {BaseAPI}
 */
export class FileUploadApi extends BaseAPI {
    /**
     * Endpoint to download assessment scores for a given assessment ID.
     * @summary Download Assessment Scores View
     * @param {string} assessmentId 
     * @param {string | null} [accessToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileUploadApi
     */
    public downloadAssessmentScoresViewApiFileAssessmentScoresDownloadAssessmentIdGet(assessmentId: string, accessToken?: string | null, options?: RawAxiosRequestConfig) {
        return FileUploadApiFp(this.configuration).downloadAssessmentScoresViewApiFileAssessmentScoresDownloadAssessmentIdGet(assessmentId, accessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint for file upload with assessment and standard details.
     * @summary File Upload Api
     * @param {string} file 
     * @param {string | null} [standardName] 
     * @param {string | null} [version] 
     * @param {string | null} [assessmentId] 
     * @param {string | null} [standardId] 
     * @param {string | null} [newAssessmentName] 
     * @param {string | null} [groupScoreOverride] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileUploadApi
     */
    public fileUploadApiApiFileAssessmentUploadPost(file: string, standardName?: string | null, version?: string | null, assessmentId?: string | null, standardId?: string | null, newAssessmentName?: string | null, groupScoreOverride?: string | null, options?: RawAxiosRequestConfig) {
        return FileUploadApiFp(this.configuration).fileUploadApiApiFileAssessmentUploadPost(file, standardName, version, assessmentId, standardId, newAssessmentName, groupScoreOverride, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Render file upload form with standard and assessment options.
     * @summary File Upload Form
     * @param {string | null} [accessToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileUploadApi
     */
    public fileUploadFormApiFileAssessmentUploadFormGet(accessToken?: string | null, options?: RawAxiosRequestConfig) {
        return FileUploadApiFp(this.configuration).fileUploadFormApiFileAssessmentUploadFormGet(accessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to download file from MinIO storage.
     * @summary Minio File Download View
     * @param {string} filePath 
     * @param {string | null} [accessToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileUploadApi
     */
    public minioFileDownloadViewApiFileDownloadGet(filePath: string, accessToken?: string | null, options?: RawAxiosRequestConfig) {
        return FileUploadApiFp(this.configuration).minioFileDownloadViewApiFileDownloadGet(filePath, accessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handle file upload from form submission.
     * @summary Submit File Upload Form
     * @param {string} file 
     * @param {string | null} [standardId] 
     * @param {string | null} [assessmentId] 
     * @param {string | null} [newAssessmentName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileUploadApi
     */
    public submitFileUploadFormApiFileAssessmentUploadFormPost(file: string, standardId?: string | null, assessmentId?: string | null, newAssessmentName?: string | null, options?: RawAxiosRequestConfig) {
        return FileUploadApiFp(this.configuration).submitFileUploadFormApiFileAssessmentUploadFormPost(file, standardId, assessmentId, newAssessmentName, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GradeSheetsApi - axios parameter creator
 * @export
 */
export const GradeSheetsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete a grade sheet and clean up associated activity scores to prevent orphans.
         * @summary Delete Gradesheet
         * @param {string} gradesheetId The ID of the grade sheet to delete
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGradesheetApiGradesheetsGradesheetIdDelete: async (gradesheetId: string, accessToken?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gradesheetId' is not null or undefined
            assertParamExists('deleteGradesheetApiGradesheetsGradesheetIdDelete', 'gradesheetId', gradesheetId)
            const localVarPath = `/api/gradesheets/{gradesheet_id}`
                .replace(`{${"gradesheet_id"}}`, encodeURIComponent(String(gradesheetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (accessToken != null) {
                localVarHeaderParameter['access-token'] = String(accessToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve grade sheets with flexible filtering options: - Get by grade sheet ID - Get all grade sheets for an assessment - Get a specific grade sheet by assessment ID and grader
         * @summary Get Gradesheets
         * @param {string | null} [gradesheetId] Get a specific grade sheet by ID
         * @param {string | null} [assessmentId] Filter by assessment ID
         * @param {string | null} [grader] Filter by grader name
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGradesheetsApiGradesheetsGet: async (gradesheetId?: string | null, assessmentId?: string | null, grader?: string | null, accessToken?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gradesheets/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gradesheetId !== undefined) {
                localVarQueryParameter['gradesheet_id'] = gradesheetId;
            }

            if (assessmentId !== undefined) {
                localVarQueryParameter['assessment_id'] = assessmentId;
            }

            if (grader !== undefined) {
                localVarQueryParameter['grader'] = grader;
            }

            if (accessToken != null) {
                localVarHeaderParameter['access-token'] = String(accessToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GradeSheetsApi - functional programming interface
 * @export
 */
export const GradeSheetsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GradeSheetsApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete a grade sheet and clean up associated activity scores to prevent orphans.
         * @summary Delete Gradesheet
         * @param {string} gradesheetId The ID of the grade sheet to delete
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGradesheetApiGradesheetsGradesheetIdDelete(gradesheetId: string, accessToken?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGradesheetApiGradesheetsGradesheetIdDelete(gradesheetId, accessToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GradeSheetsApi.deleteGradesheetApiGradesheetsGradesheetIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve grade sheets with flexible filtering options: - Get by grade sheet ID - Get all grade sheets for an assessment - Get a specific grade sheet by assessment ID and grader
         * @summary Get Gradesheets
         * @param {string | null} [gradesheetId] Get a specific grade sheet by ID
         * @param {string | null} [assessmentId] Filter by assessment ID
         * @param {string | null} [grader] Filter by grader name
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGradesheetsApiGradesheetsGet(gradesheetId?: string | null, assessmentId?: string | null, grader?: string | null, accessToken?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GradeSheetResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGradesheetsApiGradesheetsGet(gradesheetId, assessmentId, grader, accessToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GradeSheetsApi.getGradesheetsApiGradesheetsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GradeSheetsApi - factory interface
 * @export
 */
export const GradeSheetsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GradeSheetsApiFp(configuration)
    return {
        /**
         * Delete a grade sheet and clean up associated activity scores to prevent orphans.
         * @summary Delete Gradesheet
         * @param {string} gradesheetId The ID of the grade sheet to delete
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGradesheetApiGradesheetsGradesheetIdDelete(gradesheetId: string, accessToken?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteGradesheetApiGradesheetsGradesheetIdDelete(gradesheetId, accessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve grade sheets with flexible filtering options: - Get by grade sheet ID - Get all grade sheets for an assessment - Get a specific grade sheet by assessment ID and grader
         * @summary Get Gradesheets
         * @param {string | null} [gradesheetId] Get a specific grade sheet by ID
         * @param {string | null} [assessmentId] Filter by assessment ID
         * @param {string | null} [grader] Filter by grader name
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGradesheetsApiGradesheetsGet(gradesheetId?: string | null, assessmentId?: string | null, grader?: string | null, accessToken?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<GradeSheetResponse>> {
            return localVarFp.getGradesheetsApiGradesheetsGet(gradesheetId, assessmentId, grader, accessToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GradeSheetsApi - object-oriented interface
 * @export
 * @class GradeSheetsApi
 * @extends {BaseAPI}
 */
export class GradeSheetsApi extends BaseAPI {
    /**
     * Delete a grade sheet and clean up associated activity scores to prevent orphans.
     * @summary Delete Gradesheet
     * @param {string} gradesheetId The ID of the grade sheet to delete
     * @param {string | null} [accessToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GradeSheetsApi
     */
    public deleteGradesheetApiGradesheetsGradesheetIdDelete(gradesheetId: string, accessToken?: string | null, options?: RawAxiosRequestConfig) {
        return GradeSheetsApiFp(this.configuration).deleteGradesheetApiGradesheetsGradesheetIdDelete(gradesheetId, accessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve grade sheets with flexible filtering options: - Get by grade sheet ID - Get all grade sheets for an assessment - Get a specific grade sheet by assessment ID and grader
     * @summary Get Gradesheets
     * @param {string | null} [gradesheetId] Get a specific grade sheet by ID
     * @param {string | null} [assessmentId] Filter by assessment ID
     * @param {string | null} [grader] Filter by grader name
     * @param {string | null} [accessToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GradeSheetsApi
     */
    public getGradesheetsApiGradesheetsGet(gradesheetId?: string | null, assessmentId?: string | null, grader?: string | null, accessToken?: string | null, options?: RawAxiosRequestConfig) {
        return GradeSheetsApiFp(this.configuration).getGradesheetsApiGradesheetsGet(gradesheetId, assessmentId, grader, accessToken, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * JobsApi - axios parameter creator
 * @export
 */
export const JobsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetch full job details by ID.
         * @summary Get Job
         * @param {string} jobId 
         * @param {string | null} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobApiJobsJobIdGet: async (jobId: string, authorization?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getJobApiJobsJobIdGet', 'jobId', jobId)
            const localVarPath = `/api/jobs/{job_id}`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch all steps and their statuses for a specific job.
         * @summary Get Job Steps
         * @param {string} jobId 
         * @param {string | null} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobStepsApiJobsJobIdStepsGet: async (jobId: string, authorization?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getJobStepsApiJobsJobIdStepsGet', 'jobId', jobId)
            const localVarPath = `/api/jobs/{job_id}/steps`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch all jobs with minimal details.
         * @summary List Jobs
         * @param {string | null} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listJobsApiJobsGet: async (authorization?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/jobs/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OptionalHTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch just the progress of a job.
         * @summary Poll Job Progress
         * @param {string} jobId 
         * @param {string | null} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pollJobProgressApiJobsJobIdProgressGet: async (jobId: string, authorization?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('pollJobProgressApiJobsJobIdProgressGet', 'jobId', jobId)
            const localVarPath = `/api/jobs/{job_id}/progress`
                .replace(`{${"job_id"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobsApi - functional programming interface
 * @export
 */
export const JobsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = JobsApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetch full job details by ID.
         * @summary Get Job
         * @param {string} jobId 
         * @param {string | null} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobApiJobsJobIdGet(jobId: string, authorization?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobApiJobsJobIdGet(jobId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.getJobApiJobsJobIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch all steps and their statuses for a specific job.
         * @summary Get Job Steps
         * @param {string} jobId 
         * @param {string | null} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobStepsApiJobsJobIdStepsGet(jobId: string, authorization?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobStepsApiJobsJobIdStepsGet(jobId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.getJobStepsApiJobsJobIdStepsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch all jobs with minimal details.
         * @summary List Jobs
         * @param {string | null} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listJobsApiJobsGet(authorization?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: any; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listJobsApiJobsGet(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.listJobsApiJobsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch just the progress of a job.
         * @summary Poll Job Progress
         * @param {string} jobId 
         * @param {string | null} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pollJobProgressApiJobsJobIdProgressGet(jobId: string, authorization?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pollJobProgressApiJobsJobIdProgressGet(jobId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['JobsApi.pollJobProgressApiJobsJobIdProgressGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * JobsApi - factory interface
 * @export
 */
export const JobsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = JobsApiFp(configuration)
    return {
        /**
         * Fetch full job details by ID.
         * @summary Get Job
         * @param {string} jobId 
         * @param {string | null} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobApiJobsJobIdGet(jobId: string, authorization?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getJobApiJobsJobIdGet(jobId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch all steps and their statuses for a specific job.
         * @summary Get Job Steps
         * @param {string} jobId 
         * @param {string | null} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobStepsApiJobsJobIdStepsGet(jobId: string, authorization?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getJobStepsApiJobsJobIdStepsGet(jobId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch all jobs with minimal details.
         * @summary List Jobs
         * @param {string | null} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listJobsApiJobsGet(authorization?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: any; }>> {
            return localVarFp.listJobsApiJobsGet(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch just the progress of a job.
         * @summary Poll Job Progress
         * @param {string} jobId 
         * @param {string | null} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pollJobProgressApiJobsJobIdProgressGet(jobId: string, authorization?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.pollJobProgressApiJobsJobIdProgressGet(jobId, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * JobsApi - object-oriented interface
 * @export
 * @class JobsApi
 * @extends {BaseAPI}
 */
export class JobsApi extends BaseAPI {
    /**
     * Fetch full job details by ID.
     * @summary Get Job
     * @param {string} jobId 
     * @param {string | null} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public getJobApiJobsJobIdGet(jobId: string, authorization?: string | null, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).getJobApiJobsJobIdGet(jobId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch all steps and their statuses for a specific job.
     * @summary Get Job Steps
     * @param {string} jobId 
     * @param {string | null} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public getJobStepsApiJobsJobIdStepsGet(jobId: string, authorization?: string | null, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).getJobStepsApiJobsJobIdStepsGet(jobId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch all jobs with minimal details.
     * @summary List Jobs
     * @param {string | null} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public listJobsApiJobsGet(authorization?: string | null, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).listJobsApiJobsGet(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch just the progress of a job.
     * @summary Poll Job Progress
     * @param {string} jobId 
     * @param {string | null} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public pollJobProgressApiJobsJobIdProgressGet(jobId: string, authorization?: string | null, options?: RawAxiosRequestConfig) {
        return JobsApiFp(this.configuration).pollJobProgressApiJobsJobIdProgressGet(jobId, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrganizationsApi - axios parameter creator
 * @export
 */
export const OrganizationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new organization. Returns a 400 error if the organization name already exists.
         * @summary Create Organization
         * @param {OrganizationCreate} organizationCreate 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationApiOrganizationsPost: async (organizationCreate: OrganizationCreate, accessToken?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationCreate' is not null or undefined
            assertParamExists('createOrganizationApiOrganizationsPost', 'organizationCreate', organizationCreate)
            const localVarPath = `/api/organizations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (accessToken != null) {
                localVarHeaderParameter['access-token'] = String(accessToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an organization by its MongoDB ObjectId.
         * @summary Delete Organization
         * @param {string} organizationId A valid MongoDB ObjectId
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationApiOrganizationsOrganizationIdDelete: async (organizationId: string, accessToken?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('deleteOrganizationApiOrganizationsOrganizationIdDelete', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (accessToken != null) {
                localVarHeaderParameter['access-token'] = String(accessToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Organization
         * @param {string} organizationId A valid MongoDB ObjectId
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationApiOrganizationsOrganizationIdGet: async (organizationId: string, accessToken?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganizationApiOrganizationsOrganizationIdGet', 'organizationId', organizationId)
            const localVarPath = `/api/organizations/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (accessToken != null) {
                localVarHeaderParameter['access-token'] = String(accessToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Organizations
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {number | null} [page] 
         * @param {number | null} [pageSize] 
         * @param {string | null} [name] 
         * @param {string | null} [domain] 
         * @param {string | null} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsApiOrganizationsGet: async (sortBy?: string, sortOrder?: string, page?: number | null, pageSize?: number | null, name?: string | null, domain?: string | null, authorization?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/organizations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OptionalHTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Organization
         * @param {string} organizationId 
         * @param {UpdateOrganizationRequest} updateOrganizationRequest 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationApiOrganizationsOrganizationIdPut: async (organizationId: string, updateOrganizationRequest: UpdateOrganizationRequest, accessToken?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('updateOrganizationApiOrganizationsOrganizationIdPut', 'organizationId', organizationId)
            // verify required parameter 'updateOrganizationRequest' is not null or undefined
            assertParamExists('updateOrganizationApiOrganizationsOrganizationIdPut', 'updateOrganizationRequest', updateOrganizationRequest)
            const localVarPath = `/api/organizations/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (accessToken != null) {
                localVarHeaderParameter['access-token'] = String(accessToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrganizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationsApi - functional programming interface
 * @export
 */
export const OrganizationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new organization. Returns a 400 error if the organization name already exists.
         * @summary Create Organization
         * @param {OrganizationCreate} organizationCreate 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrganizationApiOrganizationsPost(organizationCreate: OrganizationCreate, accessToken?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrganizationApiOrganizationsPost(organizationCreate, accessToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.createOrganizationApiOrganizationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an organization by its MongoDB ObjectId.
         * @summary Delete Organization
         * @param {string} organizationId A valid MongoDB ObjectId
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrganizationApiOrganizationsOrganizationIdDelete(organizationId: string, accessToken?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrganizationApiOrganizationsOrganizationIdDelete(organizationId, accessToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.deleteOrganizationApiOrganizationsOrganizationIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Organization
         * @param {string} organizationId A valid MongoDB ObjectId
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationApiOrganizationsOrganizationIdGet(organizationId: string, accessToken?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationApiOrganizationsOrganizationIdGet(organizationId, accessToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.getOrganizationApiOrganizationsOrganizationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Organizations
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {number | null} [page] 
         * @param {number | null} [pageSize] 
         * @param {string | null} [name] 
         * @param {string | null} [domain] 
         * @param {string | null} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationsApiOrganizationsGet(sortBy?: string, sortOrder?: string, page?: number | null, pageSize?: number | null, name?: string | null, domain?: string | null, authorization?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseOrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationsApiOrganizationsGet(sortBy, sortOrder, page, pageSize, name, domain, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.getOrganizationsApiOrganizationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Organization
         * @param {string} organizationId 
         * @param {UpdateOrganizationRequest} updateOrganizationRequest 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationApiOrganizationsOrganizationIdPut(organizationId: string, updateOrganizationRequest: UpdateOrganizationRequest, accessToken?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationApiOrganizationsOrganizationIdPut(organizationId, updateOrganizationRequest, accessToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrganizationsApi.updateOrganizationApiOrganizationsOrganizationIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrganizationsApi - factory interface
 * @export
 */
export const OrganizationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationsApiFp(configuration)
    return {
        /**
         * Create a new organization. Returns a 400 error if the organization name already exists.
         * @summary Create Organization
         * @param {OrganizationCreate} organizationCreate 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationApiOrganizationsPost(organizationCreate: OrganizationCreate, accessToken?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationResponse> {
            return localVarFp.createOrganizationApiOrganizationsPost(organizationCreate, accessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an organization by its MongoDB ObjectId.
         * @summary Delete Organization
         * @param {string} organizationId A valid MongoDB ObjectId
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationApiOrganizationsOrganizationIdDelete(organizationId: string, accessToken?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteOrganizationApiOrganizationsOrganizationIdDelete(organizationId, accessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Organization
         * @param {string} organizationId A valid MongoDB ObjectId
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationApiOrganizationsOrganizationIdGet(organizationId: string, accessToken?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationResponse> {
            return localVarFp.getOrganizationApiOrganizationsOrganizationIdGet(organizationId, accessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Organizations
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {number | null} [page] 
         * @param {number | null} [pageSize] 
         * @param {string | null} [name] 
         * @param {string | null} [domain] 
         * @param {string | null} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsApiOrganizationsGet(sortBy?: string, sortOrder?: string, page?: number | null, pageSize?: number | null, name?: string | null, domain?: string | null, authorization?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseOrganizationResponse> {
            return localVarFp.getOrganizationsApiOrganizationsGet(sortBy, sortOrder, page, pageSize, name, domain, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Organization
         * @param {string} organizationId 
         * @param {UpdateOrganizationRequest} updateOrganizationRequest 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationApiOrganizationsOrganizationIdPut(organizationId: string, updateOrganizationRequest: UpdateOrganizationRequest, accessToken?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationResponse> {
            return localVarFp.updateOrganizationApiOrganizationsOrganizationIdPut(organizationId, updateOrganizationRequest, accessToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationsApi - object-oriented interface
 * @export
 * @class OrganizationsApi
 * @extends {BaseAPI}
 */
export class OrganizationsApi extends BaseAPI {
    /**
     * Create a new organization. Returns a 400 error if the organization name already exists.
     * @summary Create Organization
     * @param {OrganizationCreate} organizationCreate 
     * @param {string | null} [accessToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public createOrganizationApiOrganizationsPost(organizationCreate: OrganizationCreate, accessToken?: string | null, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).createOrganizationApiOrganizationsPost(organizationCreate, accessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an organization by its MongoDB ObjectId.
     * @summary Delete Organization
     * @param {string} organizationId A valid MongoDB ObjectId
     * @param {string | null} [accessToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public deleteOrganizationApiOrganizationsOrganizationIdDelete(organizationId: string, accessToken?: string | null, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).deleteOrganizationApiOrganizationsOrganizationIdDelete(organizationId, accessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Organization
     * @param {string} organizationId A valid MongoDB ObjectId
     * @param {string | null} [accessToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getOrganizationApiOrganizationsOrganizationIdGet(organizationId: string, accessToken?: string | null, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getOrganizationApiOrganizationsOrganizationIdGet(organizationId, accessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Organizations
     * @param {string} [sortBy] 
     * @param {string} [sortOrder] 
     * @param {number | null} [page] 
     * @param {number | null} [pageSize] 
     * @param {string | null} [name] 
     * @param {string | null} [domain] 
     * @param {string | null} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getOrganizationsApiOrganizationsGet(sortBy?: string, sortOrder?: string, page?: number | null, pageSize?: number | null, name?: string | null, domain?: string | null, authorization?: string | null, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getOrganizationsApiOrganizationsGet(sortBy, sortOrder, page, pageSize, name, domain, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Organization
     * @param {string} organizationId 
     * @param {UpdateOrganizationRequest} updateOrganizationRequest 
     * @param {string | null} [accessToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public updateOrganizationApiOrganizationsOrganizationIdPut(organizationId: string, updateOrganizationRequest: UpdateOrganizationRequest, accessToken?: string | null, options?: RawAxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).updateOrganizationApiOrganizationsOrganizationIdPut(organizationId, updateOrganizationRequest, accessToken, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PopulationDataUploadApi - axios parameter creator
 * @export
 */
export const PopulationDataUploadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Renders the BSIMM controls mapping upload form.
         * @summary Bsimm Controls Mapping Form
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bsimmControlsMappingFormApiAdminBsimmByVersionUploadGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/bsimm/by-version-upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OptionalHTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handles the BSIMM controls mapping file upload and initiates processing.
         * @summary Bsimm Controls Mapping Upload
         * @param {string} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bsimmControlsMappingUploadApiAdminBsimmMappingByVersionUploadPost: async (file: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('bsimmControlsMappingUploadApiAdminBsimmMappingByVersionUploadPost', 'file', file)
            const localVarPath = `/api/admin/bsimm/mapping/by-version-upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handles the population data file upload and initiates processing.
         * @summary Population Data Upload
         * @param {string} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        populationDataUploadApiAdminBsimmPopulationDataUploadPost: async (file: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('populationDataUploadApiAdminBsimmPopulationDataUploadPost', 'file', file)
            const localVarPath = `/api/admin/bsimm/population-data-upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Renders the population data upload form.
         * @summary Population Data Upload Form
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        populationDataUploadFormApiAdminBsimmPopulationDataUploadGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/bsimm/population-data-upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OptionalHTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PopulationDataUploadApi - functional programming interface
 * @export
 */
export const PopulationDataUploadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PopulationDataUploadApiAxiosParamCreator(configuration)
    return {
        /**
         * Renders the BSIMM controls mapping upload form.
         * @summary Bsimm Controls Mapping Form
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bsimmControlsMappingFormApiAdminBsimmByVersionUploadGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bsimmControlsMappingFormApiAdminBsimmByVersionUploadGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PopulationDataUploadApi.bsimmControlsMappingFormApiAdminBsimmByVersionUploadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handles the BSIMM controls mapping file upload and initiates processing.
         * @summary Bsimm Controls Mapping Upload
         * @param {string} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bsimmControlsMappingUploadApiAdminBsimmMappingByVersionUploadPost(file: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bsimmControlsMappingUploadApiAdminBsimmMappingByVersionUploadPost(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PopulationDataUploadApi.bsimmControlsMappingUploadApiAdminBsimmMappingByVersionUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handles the population data file upload and initiates processing.
         * @summary Population Data Upload
         * @param {string} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async populationDataUploadApiAdminBsimmPopulationDataUploadPost(file: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.populationDataUploadApiAdminBsimmPopulationDataUploadPost(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PopulationDataUploadApi.populationDataUploadApiAdminBsimmPopulationDataUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Renders the population data upload form.
         * @summary Population Data Upload Form
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async populationDataUploadFormApiAdminBsimmPopulationDataUploadGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.populationDataUploadFormApiAdminBsimmPopulationDataUploadGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PopulationDataUploadApi.populationDataUploadFormApiAdminBsimmPopulationDataUploadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PopulationDataUploadApi - factory interface
 * @export
 */
export const PopulationDataUploadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PopulationDataUploadApiFp(configuration)
    return {
        /**
         * Renders the BSIMM controls mapping upload form.
         * @summary Bsimm Controls Mapping Form
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bsimmControlsMappingFormApiAdminBsimmByVersionUploadGet(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.bsimmControlsMappingFormApiAdminBsimmByVersionUploadGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Handles the BSIMM controls mapping file upload and initiates processing.
         * @summary Bsimm Controls Mapping Upload
         * @param {string} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bsimmControlsMappingUploadApiAdminBsimmMappingByVersionUploadPost(file: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.bsimmControlsMappingUploadApiAdminBsimmMappingByVersionUploadPost(file, options).then((request) => request(axios, basePath));
        },
        /**
         * Handles the population data file upload and initiates processing.
         * @summary Population Data Upload
         * @param {string} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        populationDataUploadApiAdminBsimmPopulationDataUploadPost(file: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.populationDataUploadApiAdminBsimmPopulationDataUploadPost(file, options).then((request) => request(axios, basePath));
        },
        /**
         * Renders the population data upload form.
         * @summary Population Data Upload Form
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        populationDataUploadFormApiAdminBsimmPopulationDataUploadGet(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.populationDataUploadFormApiAdminBsimmPopulationDataUploadGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PopulationDataUploadApi - object-oriented interface
 * @export
 * @class PopulationDataUploadApi
 * @extends {BaseAPI}
 */
export class PopulationDataUploadApi extends BaseAPI {
    /**
     * Renders the BSIMM controls mapping upload form.
     * @summary Bsimm Controls Mapping Form
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PopulationDataUploadApi
     */
    public bsimmControlsMappingFormApiAdminBsimmByVersionUploadGet(options?: RawAxiosRequestConfig) {
        return PopulationDataUploadApiFp(this.configuration).bsimmControlsMappingFormApiAdminBsimmByVersionUploadGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handles the BSIMM controls mapping file upload and initiates processing.
     * @summary Bsimm Controls Mapping Upload
     * @param {string} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PopulationDataUploadApi
     */
    public bsimmControlsMappingUploadApiAdminBsimmMappingByVersionUploadPost(file: string, options?: RawAxiosRequestConfig) {
        return PopulationDataUploadApiFp(this.configuration).bsimmControlsMappingUploadApiAdminBsimmMappingByVersionUploadPost(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handles the population data file upload and initiates processing.
     * @summary Population Data Upload
     * @param {string} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PopulationDataUploadApi
     */
    public populationDataUploadApiAdminBsimmPopulationDataUploadPost(file: string, options?: RawAxiosRequestConfig) {
        return PopulationDataUploadApiFp(this.configuration).populationDataUploadApiAdminBsimmPopulationDataUploadPost(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Renders the population data upload form.
     * @summary Population Data Upload Form
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PopulationDataUploadApi
     */
    public populationDataUploadFormApiAdminBsimmPopulationDataUploadGet(options?: RawAxiosRequestConfig) {
        return PopulationDataUploadApiFp(this.configuration).populationDataUploadFormApiAdminBsimmPopulationDataUploadGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PopulationsApi - axios parameter creator
 * @export
 */
export const PopulationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Population By Id
         * @param {string} populationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopulationByIdApiPopulationsPopulationIdGet: async (populationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'populationId' is not null or undefined
            assertParamExists('getPopulationByIdApiPopulationsPopulationIdGet', 'populationId', populationId)
            const localVarPath = `/api/populations/{population_id}`
                .replace(`{${"population_id"}}`, encodeURIComponent(String(populationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Population Vertical By Id
         * @param {string} verticalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopulationVerticalByIdApiPopulationsVerticalsVerticalIdGet: async (verticalId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verticalId' is not null or undefined
            assertParamExists('getPopulationVerticalByIdApiPopulationsVerticalsVerticalIdGet', 'verticalId', verticalId)
            const localVarPath = `/api/populations/verticals/{vertical_id}`
                .replace(`{${"vertical_id"}}`, encodeURIComponent(String(verticalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Population Verticals
         * @param {string | null} [populationId] 
         * @param {string | null} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopulationVerticalsApiPopulationsVerticalsGet: async (populationId?: string | null, name?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/populations/verticals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (populationId !== undefined) {
                localVarQueryParameter['population_id'] = populationId;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Populations
         * @param {string | null} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopulationsApiPopulationsGet: async (name?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/populations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PopulationsApi - functional programming interface
 * @export
 */
export const PopulationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PopulationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Population By Id
         * @param {string} populationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPopulationByIdApiPopulationsPopulationIdGet(populationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PopulationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPopulationByIdApiPopulationsPopulationIdGet(populationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PopulationsApi.getPopulationByIdApiPopulationsPopulationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Population Vertical By Id
         * @param {string} verticalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPopulationVerticalByIdApiPopulationsVerticalsVerticalIdGet(verticalId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PopulationVerticalResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPopulationVerticalByIdApiPopulationsVerticalsVerticalIdGet(verticalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PopulationsApi.getPopulationVerticalByIdApiPopulationsVerticalsVerticalIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Population Verticals
         * @param {string | null} [populationId] 
         * @param {string | null} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPopulationVerticalsApiPopulationsVerticalsGet(populationId?: string | null, name?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PopulationVerticalResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPopulationVerticalsApiPopulationsVerticalsGet(populationId, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PopulationsApi.getPopulationVerticalsApiPopulationsVerticalsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Populations
         * @param {string | null} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPopulationsApiPopulationsGet(name?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PopulationResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPopulationsApiPopulationsGet(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PopulationsApi.getPopulationsApiPopulationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PopulationsApi - factory interface
 * @export
 */
export const PopulationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PopulationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Population By Id
         * @param {string} populationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopulationByIdApiPopulationsPopulationIdGet(populationId: string, options?: RawAxiosRequestConfig): AxiosPromise<PopulationResponse> {
            return localVarFp.getPopulationByIdApiPopulationsPopulationIdGet(populationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Population Vertical By Id
         * @param {string} verticalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopulationVerticalByIdApiPopulationsVerticalsVerticalIdGet(verticalId: string, options?: RawAxiosRequestConfig): AxiosPromise<PopulationVerticalResponse> {
            return localVarFp.getPopulationVerticalByIdApiPopulationsVerticalsVerticalIdGet(verticalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Population Verticals
         * @param {string | null} [populationId] 
         * @param {string | null} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopulationVerticalsApiPopulationsVerticalsGet(populationId?: string | null, name?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<PopulationVerticalResponse>> {
            return localVarFp.getPopulationVerticalsApiPopulationsVerticalsGet(populationId, name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Populations
         * @param {string | null} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopulationsApiPopulationsGet(name?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<Array<PopulationResponse>> {
            return localVarFp.getPopulationsApiPopulationsGet(name, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PopulationsApi - object-oriented interface
 * @export
 * @class PopulationsApi
 * @extends {BaseAPI}
 */
export class PopulationsApi extends BaseAPI {
    /**
     * 
     * @summary Get Population By Id
     * @param {string} populationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PopulationsApi
     */
    public getPopulationByIdApiPopulationsPopulationIdGet(populationId: string, options?: RawAxiosRequestConfig) {
        return PopulationsApiFp(this.configuration).getPopulationByIdApiPopulationsPopulationIdGet(populationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Population Vertical By Id
     * @param {string} verticalId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PopulationsApi
     */
    public getPopulationVerticalByIdApiPopulationsVerticalsVerticalIdGet(verticalId: string, options?: RawAxiosRequestConfig) {
        return PopulationsApiFp(this.configuration).getPopulationVerticalByIdApiPopulationsVerticalsVerticalIdGet(verticalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Population Verticals
     * @param {string | null} [populationId] 
     * @param {string | null} [name] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PopulationsApi
     */
    public getPopulationVerticalsApiPopulationsVerticalsGet(populationId?: string | null, name?: string | null, options?: RawAxiosRequestConfig) {
        return PopulationsApiFp(this.configuration).getPopulationVerticalsApiPopulationsVerticalsGet(populationId, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Populations
     * @param {string | null} [name] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PopulationsApi
     */
    public getPopulationsApiPopulationsGet(name?: string | null, options?: RawAxiosRequestConfig) {
        return PopulationsApiFp(this.configuration).getPopulationsApiPopulationsGet(name, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RelatedEntriesApi - axios parameter creator
 * @export
 */
export const RelatedEntriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve standard entries with optional filtering and include related entries.
         * @summary Get Related Standard Entries
         * @param {string | null} [stdId] 
         * @param {string | null} [type] 
         * @param {string | null} [domain] 
         * @param {string | null} [category] 
         * @param {string | null} [shortName] 
         * @param {string | null} [explanation] 
         * @param {string | null} [enclosingStandardVersion] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedStandardEntriesApiRelatedEntriesGet: async (stdId?: string | null, type?: string | null, domain?: string | null, category?: string | null, shortName?: string | null, explanation?: string | null, enclosingStandardVersion?: string | null, sortBy?: string, sortOrder?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/related-entries/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stdId !== undefined) {
                localVarQueryParameter['std_id'] = stdId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (shortName !== undefined) {
                localVarQueryParameter['short_name'] = shortName;
            }

            if (explanation !== undefined) {
                localVarQueryParameter['explanation'] = explanation;
            }

            if (enclosingStandardVersion !== undefined) {
                localVarQueryParameter['enclosing_standard_version'] = enclosingStandardVersion;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RelatedEntriesApi - functional programming interface
 * @export
 */
export const RelatedEntriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RelatedEntriesApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve standard entries with optional filtering and include related entries.
         * @summary Get Related Standard Entries
         * @param {string | null} [stdId] 
         * @param {string | null} [type] 
         * @param {string | null} [domain] 
         * @param {string | null} [category] 
         * @param {string | null} [shortName] 
         * @param {string | null} [explanation] 
         * @param {string | null} [enclosingStandardVersion] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelatedStandardEntriesApiRelatedEntriesGet(stdId?: string | null, type?: string | null, domain?: string | null, category?: string | null, shortName?: string | null, explanation?: string | null, enclosingStandardVersion?: string | null, sortBy?: string, sortOrder?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RelatedStandardEntryResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelatedStandardEntriesApiRelatedEntriesGet(stdId, type, domain, category, shortName, explanation, enclosingStandardVersion, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RelatedEntriesApi.getRelatedStandardEntriesApiRelatedEntriesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RelatedEntriesApi - factory interface
 * @export
 */
export const RelatedEntriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RelatedEntriesApiFp(configuration)
    return {
        /**
         * Retrieve standard entries with optional filtering and include related entries.
         * @summary Get Related Standard Entries
         * @param {string | null} [stdId] 
         * @param {string | null} [type] 
         * @param {string | null} [domain] 
         * @param {string | null} [category] 
         * @param {string | null} [shortName] 
         * @param {string | null} [explanation] 
         * @param {string | null} [enclosingStandardVersion] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedStandardEntriesApiRelatedEntriesGet(stdId?: string | null, type?: string | null, domain?: string | null, category?: string | null, shortName?: string | null, explanation?: string | null, enclosingStandardVersion?: string | null, sortBy?: string, sortOrder?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RelatedStandardEntryResponse>> {
            return localVarFp.getRelatedStandardEntriesApiRelatedEntriesGet(stdId, type, domain, category, shortName, explanation, enclosingStandardVersion, sortBy, sortOrder, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RelatedEntriesApi - object-oriented interface
 * @export
 * @class RelatedEntriesApi
 * @extends {BaseAPI}
 */
export class RelatedEntriesApi extends BaseAPI {
    /**
     * Retrieve standard entries with optional filtering and include related entries.
     * @summary Get Related Standard Entries
     * @param {string | null} [stdId] 
     * @param {string | null} [type] 
     * @param {string | null} [domain] 
     * @param {string | null} [category] 
     * @param {string | null} [shortName] 
     * @param {string | null} [explanation] 
     * @param {string | null} [enclosingStandardVersion] 
     * @param {string} [sortBy] 
     * @param {string} [sortOrder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelatedEntriesApi
     */
    public getRelatedStandardEntriesApiRelatedEntriesGet(stdId?: string | null, type?: string | null, domain?: string | null, category?: string | null, shortName?: string | null, explanation?: string | null, enclosingStandardVersion?: string | null, sortBy?: string, sortOrder?: string, options?: RawAxiosRequestConfig) {
        return RelatedEntriesApiFp(this.configuration).getRelatedStandardEntriesApiRelatedEntriesGet(stdId, type, domain, category, shortName, explanation, enclosingStandardVersion, sortBy, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ScoresApi - axios parameter creator
 * @export
 */
export const ScoresApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Bar Chart View
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        barChartViewApiScoresBarChartAssessmentIdGet: async (assessmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('barChartViewApiScoresBarChartAssessmentIdGet', 'assessmentId', assessmentId)
            const localVarPath = `/api/scores/bar-chart/{assessment_id}`
                .replace(`{${"assessment_id"}}`, encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bsimm Assessment View
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bsimmAssessmentViewApiScoresBsimmAssessmentAssessmentIdGet: async (assessmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('bsimmAssessmentViewApiScoresBsimmAssessmentAssessmentIdGet', 'assessmentId', assessmentId)
            const localVarPath = `/api/scores/bsimm_assessment/{assessment_id}`
                .replace(`{${"assessment_id"}}`, encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bsimm Table View
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bsimmTableViewApiScoresBsimmTableAssessmentIdGet: async (assessmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('bsimmTableViewApiScoresBsimmTableAssessmentIdGet', 'assessmentId', assessmentId)
            const localVarPath = `/api/scores/bsimm-table/{assessment_id}`
                .replace(`{${"assessment_id"}}`, encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check scores for a given assessment and filename.  The endpoint validates: - assessment_id (must be a valid MongoDB ObjectID) - filename (must be non-empty string)  Returns:     JSONResponse with operation status
         * @summary Check Scores
         * @param {string} assessmentId 
         * @param {string} filename 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkScoresApiScoresAssessmentIdCheckScoresPost: async (assessmentId: string, filename: string, accessToken?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('checkScoresApiScoresAssessmentIdCheckScoresPost', 'assessmentId', assessmentId)
            // verify required parameter 'filename' is not null or undefined
            assertParamExists('checkScoresApiScoresAssessmentIdCheckScoresPost', 'filename', filename)
            const localVarPath = `/api/scores/{assessment_id}/check_scores`
                .replace(`{${"assessment_id"}}`, encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }

            if (accessToken != null) {
                localVarHeaderParameter['access-token'] = String(accessToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handle score creation with assessment ID provided as a path parameter.
         * @summary Create Score With Path Param
         * @param {string} assessmentId The ID of the assessment
         * @param {ScoreUpdateRequest} [scoreUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScoreWithPathParamApiScoresAssessmentIdPost: async (assessmentId: string, scoreUpdateRequest?: ScoreUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('createScoreWithPathParamApiScoresAssessmentIdPost', 'assessmentId', assessmentId)
            const localVarPath = `/api/scores/{assessment_id}`
                .replace(`{${"assessment_id"}}`, encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(scoreUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handle score creation with assessment ID provided as a query parameter.
         * @summary Create Score With Query Param
         * @param {ScoreUpdateRequest} [scoreUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScoreWithQueryParamApiScoresPost: async (scoreUpdateRequest?: ScoreUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/scores/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(scoreUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Donut Chart View
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        donutChartViewApiScoresDonutChartAssessmentIdGet: async (assessmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('donutChartViewApiScoresDonutChartAssessmentIdGet', 'assessmentId', assessmentId)
            const localVarPath = `/api/scores/donut-chart/{assessment_id}`
                .replace(`{${"assessment_id"}}`, encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Activity Score
         * @param {string} assessmentId 
         * @param {string} activitySpec 
         * @param {boolean} [scoreChecks] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityScoreApiScoresAssessmentIdActivityScoreActivitySpecGet: async (assessmentId: string, activitySpec: string, scoreChecks?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('getActivityScoreApiScoresAssessmentIdActivityScoreActivitySpecGet', 'assessmentId', assessmentId)
            // verify required parameter 'activitySpec' is not null or undefined
            assertParamExists('getActivityScoreApiScoresAssessmentIdActivityScoreActivitySpecGet', 'activitySpec', activitySpec)
            const localVarPath = `/api/scores/{assessment_id}/activity_score/{activity_spec}`
                .replace(`{${"assessment_id"}}`, encodeURIComponent(String(assessmentId)))
                .replace(`{${"activity_spec"}}`, encodeURIComponent(String(activitySpec)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (scoreChecks !== undefined) {
                localVarQueryParameter['score_checks'] = scoreChecks;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Activity Score
         * @param {string} assessmentId 
         * @param {string} activitySpec 
         * @param {boolean} [scoreChecks] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityScoreApiScoresAssessmentIdScoresAndChecksActivitySpecGet: async (assessmentId: string, activitySpec: string, scoreChecks?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('getActivityScoreApiScoresAssessmentIdScoresAndChecksActivitySpecGet', 'assessmentId', assessmentId)
            // verify required parameter 'activitySpec' is not null or undefined
            assertParamExists('getActivityScoreApiScoresAssessmentIdScoresAndChecksActivitySpecGet', 'activitySpec', activitySpec)
            const localVarPath = `/api/scores/{assessment_id}/scores_and_checks/{activity_spec}`
                .replace(`{${"assessment_id"}}`, encodeURIComponent(String(assessmentId)))
                .replace(`{${"activity_spec"}}`, encodeURIComponent(String(activitySpec)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (scoreChecks !== undefined) {
                localVarQueryParameter['score_checks'] = scoreChecks;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Score Checks
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoreChecksApiScoresScoreChecksGet: async (assessmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('getScoreChecksApiScoresScoreChecksGet', 'assessmentId', assessmentId)
            const localVarPath = `/api/scores/score_checks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (assessmentId !== undefined) {
                localVarQueryParameter['assessment_id'] = assessmentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve activity scores for a given assessment ID via path parameter.
         * @summary Get Scores By Path
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoresByPathApiScoresAssessmentIdGet: async (assessmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('getScoresByPathApiScoresAssessmentIdGet', 'assessmentId', assessmentId)
            const localVarPath = `/api/scores/{assessment_id}`
                .replace(`{${"assessment_id"}}`, encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve activity scores for a given assessment ID via query parameter.
         * @summary Get Scores Root
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoresRootApiScoresGet: async (assessmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('getScoresRootApiScoresGet', 'assessmentId', assessmentId)
            const localVarPath = `/api/scores/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (assessmentId !== undefined) {
                localVarQueryParameter['assessment_id'] = assessmentId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Radar Graph View
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        radarGraphViewApiScoresRadarGraphAssessmentIdGet: async (assessmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('radarGraphViewApiScoresRadarGraphAssessmentIdGet', 'assessmentId', assessmentId)
            const localVarPath = `/api/scores/radar-graph/{assessment_id}`
                .replace(`{${"assessment_id"}}`, encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Score Form
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScoreFormApiScoresUpdateFormGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/scores/update_form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScoresApi - functional programming interface
 * @export
 */
export const ScoresApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ScoresApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Bar Chart View
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async barChartViewApiScoresBarChartAssessmentIdGet(assessmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.barChartViewApiScoresBarChartAssessmentIdGet(assessmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScoresApi.barChartViewApiScoresBarChartAssessmentIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Bsimm Assessment View
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bsimmAssessmentViewApiScoresBsimmAssessmentAssessmentIdGet(assessmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bsimmAssessmentViewApiScoresBsimmAssessmentAssessmentIdGet(assessmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScoresApi.bsimmAssessmentViewApiScoresBsimmAssessmentAssessmentIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Bsimm Table View
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bsimmTableViewApiScoresBsimmTableAssessmentIdGet(assessmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bsimmTableViewApiScoresBsimmTableAssessmentIdGet(assessmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScoresApi.bsimmTableViewApiScoresBsimmTableAssessmentIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Check scores for a given assessment and filename.  The endpoint validates: - assessment_id (must be a valid MongoDB ObjectID) - filename (must be non-empty string)  Returns:     JSONResponse with operation status
         * @summary Check Scores
         * @param {string} assessmentId 
         * @param {string} filename 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkScoresApiScoresAssessmentIdCheckScoresPost(assessmentId: string, filename: string, accessToken?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkScoresApiScoresAssessmentIdCheckScoresPost(assessmentId, filename, accessToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScoresApi.checkScoresApiScoresAssessmentIdCheckScoresPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handle score creation with assessment ID provided as a path parameter.
         * @summary Create Score With Path Param
         * @param {string} assessmentId The ID of the assessment
         * @param {ScoreUpdateRequest} [scoreUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createScoreWithPathParamApiScoresAssessmentIdPost(assessmentId: string, scoreUpdateRequest?: ScoreUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScoreCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createScoreWithPathParamApiScoresAssessmentIdPost(assessmentId, scoreUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScoresApi.createScoreWithPathParamApiScoresAssessmentIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handle score creation with assessment ID provided as a query parameter.
         * @summary Create Score With Query Param
         * @param {ScoreUpdateRequest} [scoreUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createScoreWithQueryParamApiScoresPost(scoreUpdateRequest?: ScoreUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScoreCreationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createScoreWithQueryParamApiScoresPost(scoreUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScoresApi.createScoreWithQueryParamApiScoresPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Donut Chart View
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async donutChartViewApiScoresDonutChartAssessmentIdGet(assessmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.donutChartViewApiScoresDonutChartAssessmentIdGet(assessmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScoresApi.donutChartViewApiScoresDonutChartAssessmentIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Activity Score
         * @param {string} assessmentId 
         * @param {string} activitySpec 
         * @param {boolean} [scoreChecks] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivityScoreApiScoresAssessmentIdActivityScoreActivitySpecGet(assessmentId: string, activitySpec: string, scoreChecks?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScoreResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivityScoreApiScoresAssessmentIdActivityScoreActivitySpecGet(assessmentId, activitySpec, scoreChecks, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScoresApi.getActivityScoreApiScoresAssessmentIdActivityScoreActivitySpecGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Activity Score
         * @param {string} assessmentId 
         * @param {string} activitySpec 
         * @param {boolean} [scoreChecks] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivityScoreApiScoresAssessmentIdScoresAndChecksActivitySpecGet(assessmentId: string, activitySpec: string, scoreChecks?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScoreResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivityScoreApiScoresAssessmentIdScoresAndChecksActivitySpecGet(assessmentId, activitySpec, scoreChecks, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScoresApi.getActivityScoreApiScoresAssessmentIdScoresAndChecksActivitySpecGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Score Checks
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScoreChecksApiScoresScoreChecksGet(assessmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentScoreResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScoreChecksApiScoresScoreChecksGet(assessmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScoresApi.getScoreChecksApiScoresScoreChecksGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve activity scores for a given assessment ID via path parameter.
         * @summary Get Scores By Path
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScoresByPathApiScoresAssessmentIdGet(assessmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentScoreResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScoresByPathApiScoresAssessmentIdGet(assessmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScoresApi.getScoresByPathApiScoresAssessmentIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve activity scores for a given assessment ID via query parameter.
         * @summary Get Scores Root
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScoresRootApiScoresGet(assessmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentScoreResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScoresRootApiScoresGet(assessmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScoresApi.getScoresRootApiScoresGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Radar Graph View
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async radarGraphViewApiScoresRadarGraphAssessmentIdGet(assessmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.radarGraphViewApiScoresRadarGraphAssessmentIdGet(assessmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScoresApi.radarGraphViewApiScoresRadarGraphAssessmentIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Score Form
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateScoreFormApiScoresUpdateFormGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateScoreFormApiScoresUpdateFormGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScoresApi.updateScoreFormApiScoresUpdateFormGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ScoresApi - factory interface
 * @export
 */
export const ScoresApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ScoresApiFp(configuration)
    return {
        /**
         * 
         * @summary Bar Chart View
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        barChartViewApiScoresBarChartAssessmentIdGet(assessmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.barChartViewApiScoresBarChartAssessmentIdGet(assessmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bsimm Assessment View
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bsimmAssessmentViewApiScoresBsimmAssessmentAssessmentIdGet(assessmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.bsimmAssessmentViewApiScoresBsimmAssessmentAssessmentIdGet(assessmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bsimm Table View
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bsimmTableViewApiScoresBsimmTableAssessmentIdGet(assessmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.bsimmTableViewApiScoresBsimmTableAssessmentIdGet(assessmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Check scores for a given assessment and filename.  The endpoint validates: - assessment_id (must be a valid MongoDB ObjectID) - filename (must be non-empty string)  Returns:     JSONResponse with operation status
         * @summary Check Scores
         * @param {string} assessmentId 
         * @param {string} filename 
         * @param {string | null} [accessToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkScoresApiScoresAssessmentIdCheckScoresPost(assessmentId: string, filename: string, accessToken?: string | null, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.checkScoresApiScoresAssessmentIdCheckScoresPost(assessmentId, filename, accessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Handle score creation with assessment ID provided as a path parameter.
         * @summary Create Score With Path Param
         * @param {string} assessmentId The ID of the assessment
         * @param {ScoreUpdateRequest} [scoreUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScoreWithPathParamApiScoresAssessmentIdPost(assessmentId: string, scoreUpdateRequest?: ScoreUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ScoreCreationResponse> {
            return localVarFp.createScoreWithPathParamApiScoresAssessmentIdPost(assessmentId, scoreUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Handle score creation with assessment ID provided as a query parameter.
         * @summary Create Score With Query Param
         * @param {ScoreUpdateRequest} [scoreUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScoreWithQueryParamApiScoresPost(scoreUpdateRequest?: ScoreUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ScoreCreationResponse> {
            return localVarFp.createScoreWithQueryParamApiScoresPost(scoreUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Donut Chart View
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        donutChartViewApiScoresDonutChartAssessmentIdGet(assessmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.donutChartViewApiScoresDonutChartAssessmentIdGet(assessmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Activity Score
         * @param {string} assessmentId 
         * @param {string} activitySpec 
         * @param {boolean} [scoreChecks] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityScoreApiScoresAssessmentIdActivityScoreActivitySpecGet(assessmentId: string, activitySpec: string, scoreChecks?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ScoreResponse> {
            return localVarFp.getActivityScoreApiScoresAssessmentIdActivityScoreActivitySpecGet(assessmentId, activitySpec, scoreChecks, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Activity Score
         * @param {string} assessmentId 
         * @param {string} activitySpec 
         * @param {boolean} [scoreChecks] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityScoreApiScoresAssessmentIdScoresAndChecksActivitySpecGet(assessmentId: string, activitySpec: string, scoreChecks?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ScoreResponse> {
            return localVarFp.getActivityScoreApiScoresAssessmentIdScoresAndChecksActivitySpecGet(assessmentId, activitySpec, scoreChecks, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Score Checks
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoreChecksApiScoresScoreChecksGet(assessmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<AssessmentScoreResponse> {
            return localVarFp.getScoreChecksApiScoresScoreChecksGet(assessmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve activity scores for a given assessment ID via path parameter.
         * @summary Get Scores By Path
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoresByPathApiScoresAssessmentIdGet(assessmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<AssessmentScoreResponse> {
            return localVarFp.getScoresByPathApiScoresAssessmentIdGet(assessmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve activity scores for a given assessment ID via query parameter.
         * @summary Get Scores Root
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScoresRootApiScoresGet(assessmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<AssessmentScoreResponse> {
            return localVarFp.getScoresRootApiScoresGet(assessmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Radar Graph View
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        radarGraphViewApiScoresRadarGraphAssessmentIdGet(assessmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.radarGraphViewApiScoresRadarGraphAssessmentIdGet(assessmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Score Form
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScoreFormApiScoresUpdateFormGet(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.updateScoreFormApiScoresUpdateFormGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ScoresApi - object-oriented interface
 * @export
 * @class ScoresApi
 * @extends {BaseAPI}
 */
export class ScoresApi extends BaseAPI {
    /**
     * 
     * @summary Bar Chart View
     * @param {string} assessmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoresApi
     */
    public barChartViewApiScoresBarChartAssessmentIdGet(assessmentId: string, options?: RawAxiosRequestConfig) {
        return ScoresApiFp(this.configuration).barChartViewApiScoresBarChartAssessmentIdGet(assessmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bsimm Assessment View
     * @param {string} assessmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoresApi
     */
    public bsimmAssessmentViewApiScoresBsimmAssessmentAssessmentIdGet(assessmentId: string, options?: RawAxiosRequestConfig) {
        return ScoresApiFp(this.configuration).bsimmAssessmentViewApiScoresBsimmAssessmentAssessmentIdGet(assessmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bsimm Table View
     * @param {string} assessmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoresApi
     */
    public bsimmTableViewApiScoresBsimmTableAssessmentIdGet(assessmentId: string, options?: RawAxiosRequestConfig) {
        return ScoresApiFp(this.configuration).bsimmTableViewApiScoresBsimmTableAssessmentIdGet(assessmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check scores for a given assessment and filename.  The endpoint validates: - assessment_id (must be a valid MongoDB ObjectID) - filename (must be non-empty string)  Returns:     JSONResponse with operation status
     * @summary Check Scores
     * @param {string} assessmentId 
     * @param {string} filename 
     * @param {string | null} [accessToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoresApi
     */
    public checkScoresApiScoresAssessmentIdCheckScoresPost(assessmentId: string, filename: string, accessToken?: string | null, options?: RawAxiosRequestConfig) {
        return ScoresApiFp(this.configuration).checkScoresApiScoresAssessmentIdCheckScoresPost(assessmentId, filename, accessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handle score creation with assessment ID provided as a path parameter.
     * @summary Create Score With Path Param
     * @param {string} assessmentId The ID of the assessment
     * @param {ScoreUpdateRequest} [scoreUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoresApi
     */
    public createScoreWithPathParamApiScoresAssessmentIdPost(assessmentId: string, scoreUpdateRequest?: ScoreUpdateRequest, options?: RawAxiosRequestConfig) {
        return ScoresApiFp(this.configuration).createScoreWithPathParamApiScoresAssessmentIdPost(assessmentId, scoreUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handle score creation with assessment ID provided as a query parameter.
     * @summary Create Score With Query Param
     * @param {ScoreUpdateRequest} [scoreUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoresApi
     */
    public createScoreWithQueryParamApiScoresPost(scoreUpdateRequest?: ScoreUpdateRequest, options?: RawAxiosRequestConfig) {
        return ScoresApiFp(this.configuration).createScoreWithQueryParamApiScoresPost(scoreUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Donut Chart View
     * @param {string} assessmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoresApi
     */
    public donutChartViewApiScoresDonutChartAssessmentIdGet(assessmentId: string, options?: RawAxiosRequestConfig) {
        return ScoresApiFp(this.configuration).donutChartViewApiScoresDonutChartAssessmentIdGet(assessmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Activity Score
     * @param {string} assessmentId 
     * @param {string} activitySpec 
     * @param {boolean} [scoreChecks] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoresApi
     */
    public getActivityScoreApiScoresAssessmentIdActivityScoreActivitySpecGet(assessmentId: string, activitySpec: string, scoreChecks?: boolean, options?: RawAxiosRequestConfig) {
        return ScoresApiFp(this.configuration).getActivityScoreApiScoresAssessmentIdActivityScoreActivitySpecGet(assessmentId, activitySpec, scoreChecks, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Activity Score
     * @param {string} assessmentId 
     * @param {string} activitySpec 
     * @param {boolean} [scoreChecks] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoresApi
     */
    public getActivityScoreApiScoresAssessmentIdScoresAndChecksActivitySpecGet(assessmentId: string, activitySpec: string, scoreChecks?: boolean, options?: RawAxiosRequestConfig) {
        return ScoresApiFp(this.configuration).getActivityScoreApiScoresAssessmentIdScoresAndChecksActivitySpecGet(assessmentId, activitySpec, scoreChecks, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Score Checks
     * @param {string} assessmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoresApi
     */
    public getScoreChecksApiScoresScoreChecksGet(assessmentId: string, options?: RawAxiosRequestConfig) {
        return ScoresApiFp(this.configuration).getScoreChecksApiScoresScoreChecksGet(assessmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve activity scores for a given assessment ID via path parameter.
     * @summary Get Scores By Path
     * @param {string} assessmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoresApi
     */
    public getScoresByPathApiScoresAssessmentIdGet(assessmentId: string, options?: RawAxiosRequestConfig) {
        return ScoresApiFp(this.configuration).getScoresByPathApiScoresAssessmentIdGet(assessmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve activity scores for a given assessment ID via query parameter.
     * @summary Get Scores Root
     * @param {string} assessmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoresApi
     */
    public getScoresRootApiScoresGet(assessmentId: string, options?: RawAxiosRequestConfig) {
        return ScoresApiFp(this.configuration).getScoresRootApiScoresGet(assessmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Radar Graph View
     * @param {string} assessmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoresApi
     */
    public radarGraphViewApiScoresRadarGraphAssessmentIdGet(assessmentId: string, options?: RawAxiosRequestConfig) {
        return ScoresApiFp(this.configuration).radarGraphViewApiScoresRadarGraphAssessmentIdGet(assessmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Score Form
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScoresApi
     */
    public updateScoreFormApiScoresUpdateFormGet(options?: RawAxiosRequestConfig) {
        return ScoresApiFp(this.configuration).updateScoreFormApiScoresUpdateFormGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StandardEntriesApi - axios parameter creator
 * @export
 */
export const StandardEntriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Standard Entries
         * @param {string | null} [stdId] 
         * @param {string | null} [type] 
         * @param {string | null} [domain] 
         * @param {string | null} [category] 
         * @param {string | null} [shortName] 
         * @param {string | null} [explanation] 
         * @param {string | null} [enclosingStandardVersion] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStandardEntriesApiStandardEntriesGet: async (stdId?: string | null, type?: string | null, domain?: string | null, category?: string | null, shortName?: string | null, explanation?: string | null, enclosingStandardVersion?: string | null, sortBy?: string, sortOrder?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/standard-entries/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stdId !== undefined) {
                localVarQueryParameter['std_id'] = stdId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (shortName !== undefined) {
                localVarQueryParameter['short_name'] = shortName;
            }

            if (explanation !== undefined) {
                localVarQueryParameter['explanation'] = explanation;
            }

            if (enclosingStandardVersion !== undefined) {
                localVarQueryParameter['enclosing_standard_version'] = enclosingStandardVersion;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Standard Entry
         * @param {string} standardEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStandardEntryApiStandardEntriesStandardEntryIdGet: async (standardEntryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'standardEntryId' is not null or undefined
            assertParamExists('getStandardEntryApiStandardEntriesStandardEntryIdGet', 'standardEntryId', standardEntryId)
            const localVarPath = `/api/standard-entries/{standard_entry_id}`
                .replace(`{${"standard_entry_id"}}`, encodeURIComponent(String(standardEntryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StandardEntriesApi - functional programming interface
 * @export
 */
export const StandardEntriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StandardEntriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Standard Entries
         * @param {string | null} [stdId] 
         * @param {string | null} [type] 
         * @param {string | null} [domain] 
         * @param {string | null} [category] 
         * @param {string | null} [shortName] 
         * @param {string | null} [explanation] 
         * @param {string | null} [enclosingStandardVersion] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStandardEntriesApiStandardEntriesGet(stdId?: string | null, type?: string | null, domain?: string | null, category?: string | null, shortName?: string | null, explanation?: string | null, enclosingStandardVersion?: string | null, sortBy?: string, sortOrder?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedResponseStandardEntryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStandardEntriesApiStandardEntriesGet(stdId, type, domain, category, shortName, explanation, enclosingStandardVersion, sortBy, sortOrder, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StandardEntriesApi.getStandardEntriesApiStandardEntriesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Standard Entry
         * @param {string} standardEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStandardEntryApiStandardEntriesStandardEntryIdGet(standardEntryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StandardEntryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStandardEntryApiStandardEntriesStandardEntryIdGet(standardEntryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StandardEntriesApi.getStandardEntryApiStandardEntriesStandardEntryIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StandardEntriesApi - factory interface
 * @export
 */
export const StandardEntriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StandardEntriesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Standard Entries
         * @param {string | null} [stdId] 
         * @param {string | null} [type] 
         * @param {string | null} [domain] 
         * @param {string | null} [category] 
         * @param {string | null} [shortName] 
         * @param {string | null} [explanation] 
         * @param {string | null} [enclosingStandardVersion] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStandardEntriesApiStandardEntriesGet(stdId?: string | null, type?: string | null, domain?: string | null, category?: string | null, shortName?: string | null, explanation?: string | null, enclosingStandardVersion?: string | null, sortBy?: string, sortOrder?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedResponseStandardEntryResponse> {
            return localVarFp.getStandardEntriesApiStandardEntriesGet(stdId, type, domain, category, shortName, explanation, enclosingStandardVersion, sortBy, sortOrder, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Standard Entry
         * @param {string} standardEntryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStandardEntryApiStandardEntriesStandardEntryIdGet(standardEntryId: string, options?: RawAxiosRequestConfig): AxiosPromise<StandardEntryResponse> {
            return localVarFp.getStandardEntryApiStandardEntriesStandardEntryIdGet(standardEntryId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StandardEntriesApi - object-oriented interface
 * @export
 * @class StandardEntriesApi
 * @extends {BaseAPI}
 */
export class StandardEntriesApi extends BaseAPI {
    /**
     * 
     * @summary Get Standard Entries
     * @param {string | null} [stdId] 
     * @param {string | null} [type] 
     * @param {string | null} [domain] 
     * @param {string | null} [category] 
     * @param {string | null} [shortName] 
     * @param {string | null} [explanation] 
     * @param {string | null} [enclosingStandardVersion] 
     * @param {string} [sortBy] 
     * @param {string} [sortOrder] 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StandardEntriesApi
     */
    public getStandardEntriesApiStandardEntriesGet(stdId?: string | null, type?: string | null, domain?: string | null, category?: string | null, shortName?: string | null, explanation?: string | null, enclosingStandardVersion?: string | null, sortBy?: string, sortOrder?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return StandardEntriesApiFp(this.configuration).getStandardEntriesApiStandardEntriesGet(stdId, type, domain, category, shortName, explanation, enclosingStandardVersion, sortBy, sortOrder, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Standard Entry
     * @param {string} standardEntryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StandardEntriesApi
     */
    public getStandardEntryApiStandardEntriesStandardEntryIdGet(standardEntryId: string, options?: RawAxiosRequestConfig) {
        return StandardEntriesApiFp(this.configuration).getStandardEntryApiStandardEntriesStandardEntryIdGet(standardEntryId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StandardsApi - axios parameter creator
 * @export
 */
export const StandardsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve standards with optional filtering by name, version, group, integer, or float fields. Supports sorting by name, version, group, integer, or float fields.
         * @summary Get Standards
         * @param {string | null} [name] 
         * @param {string | null} [version] 
         * @param {string | null} [group] 
         * @param {number | null} [someIntField] 
         * @param {number | null} [someFloatField] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStandardsApiStandardsGet: async (name?: string | null, version?: string | null, group?: string | null, someIntField?: number | null, someFloatField?: number | null, sortBy?: string, sortOrder?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/standards/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }

            if (someIntField !== undefined) {
                localVarQueryParameter['some_int_field'] = someIntField;
            }

            if (someFloatField !== undefined) {
                localVarQueryParameter['some_float_field'] = someFloatField;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StandardsApi - functional programming interface
 * @export
 */
export const StandardsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StandardsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve standards with optional filtering by name, version, group, integer, or float fields. Supports sorting by name, version, group, integer, or float fields.
         * @summary Get Standards
         * @param {string | null} [name] 
         * @param {string | null} [version] 
         * @param {string | null} [group] 
         * @param {number | null} [someIntField] 
         * @param {number | null} [someFloatField] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStandardsApiStandardsGet(name?: string | null, version?: string | null, group?: string | null, someIntField?: number | null, someFloatField?: number | null, sortBy?: string, sortOrder?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StandardResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStandardsApiStandardsGet(name, version, group, someIntField, someFloatField, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StandardsApi.getStandardsApiStandardsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StandardsApi - factory interface
 * @export
 */
export const StandardsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StandardsApiFp(configuration)
    return {
        /**
         * Retrieve standards with optional filtering by name, version, group, integer, or float fields. Supports sorting by name, version, group, integer, or float fields.
         * @summary Get Standards
         * @param {string | null} [name] 
         * @param {string | null} [version] 
         * @param {string | null} [group] 
         * @param {number | null} [someIntField] 
         * @param {number | null} [someFloatField] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStandardsApiStandardsGet(name?: string | null, version?: string | null, group?: string | null, someIntField?: number | null, someFloatField?: number | null, sortBy?: string, sortOrder?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<StandardResponse>> {
            return localVarFp.getStandardsApiStandardsGet(name, version, group, someIntField, someFloatField, sortBy, sortOrder, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StandardsApi - object-oriented interface
 * @export
 * @class StandardsApi
 * @extends {BaseAPI}
 */
export class StandardsApi extends BaseAPI {
    /**
     * Retrieve standards with optional filtering by name, version, group, integer, or float fields. Supports sorting by name, version, group, integer, or float fields.
     * @summary Get Standards
     * @param {string | null} [name] 
     * @param {string | null} [version] 
     * @param {string | null} [group] 
     * @param {number | null} [someIntField] 
     * @param {number | null} [someFloatField] 
     * @param {string} [sortBy] 
     * @param {string} [sortOrder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StandardsApi
     */
    public getStandardsApiStandardsGet(name?: string | null, version?: string | null, group?: string | null, someIntField?: number | null, someFloatField?: number | null, sortBy?: string, sortOrder?: string, options?: RawAxiosRequestConfig) {
        return StandardsApiFp(this.configuration).getStandardsApiStandardsGet(name, version, group, someIntField, someFloatField, sortBy, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StubLoginApi - axios parameter creator
 * @export
 */
export const StubLoginApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Render the Auth0 login test page and handle redirect after successful login
         * @summary Auth0 Test Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auth0TestPageApiStubLoginAuth0TestGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/stub_login/auth0-test/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StubLoginApi - functional programming interface
 * @export
 */
export const StubLoginApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StubLoginApiAxiosParamCreator(configuration)
    return {
        /**
         * Render the Auth0 login test page and handle redirect after successful login
         * @summary Auth0 Test Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async auth0TestPageApiStubLoginAuth0TestGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.auth0TestPageApiStubLoginAuth0TestGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StubLoginApi.auth0TestPageApiStubLoginAuth0TestGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StubLoginApi - factory interface
 * @export
 */
export const StubLoginApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StubLoginApiFp(configuration)
    return {
        /**
         * Render the Auth0 login test page and handle redirect after successful login
         * @summary Auth0 Test Page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        auth0TestPageApiStubLoginAuth0TestGet(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.auth0TestPageApiStubLoginAuth0TestGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StubLoginApi - object-oriented interface
 * @export
 * @class StubLoginApi
 * @extends {BaseAPI}
 */
export class StubLoginApi extends BaseAPI {
    /**
     * Render the Auth0 login test page and handle redirect after successful login
     * @summary Auth0 Test Page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StubLoginApi
     */
    public auth0TestPageApiStubLoginAuth0TestGet(options?: RawAxiosRequestConfig) {
        return StubLoginApiFp(this.configuration).auth0TestPageApiStubLoginAuth0TestGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TokenManagerApi - axios parameter creator
 * @export
 */
export const TokenManagerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Reveal a specific token\'s value to the authenticated owner
         * @summary Reveal Token
         * @param {string} tokenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revealTokenApiTokenManagerTokenIdRevealGet: async (tokenId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenId' is not null or undefined
            assertParamExists('revealTokenApiTokenManagerTokenIdRevealGet', 'tokenId', tokenId)
            const localVarPath = `/api/token-manager/{token_id}/reveal`
                .replace(`{${"token_id"}}`, encodeURIComponent(String(tokenId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OptionalHTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * HTML endpoint to manage authentication tokens
         * @summary Token Manager Ui
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenManagerUiApiTokenManagerGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/token-manager/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Simple endpoint to verify if a token is valid.  Args:     profile: User profile extracted from the authorization token      Returns:     dict: Simple success response
         * @summary Verify Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTokenApiTokenManagerVerifyGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/token-manager/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OptionalHTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TokenManagerApi - functional programming interface
 * @export
 */
export const TokenManagerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TokenManagerApiAxiosParamCreator(configuration)
    return {
        /**
         * Reveal a specific token\'s value to the authenticated owner
         * @summary Reveal Token
         * @param {string} tokenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revealTokenApiTokenManagerTokenIdRevealGet(tokenId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revealTokenApiTokenManagerTokenIdRevealGet(tokenId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TokenManagerApi.revealTokenApiTokenManagerTokenIdRevealGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * HTML endpoint to manage authentication tokens
         * @summary Token Manager Ui
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tokenManagerUiApiTokenManagerGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tokenManagerUiApiTokenManagerGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TokenManagerApi.tokenManagerUiApiTokenManagerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Simple endpoint to verify if a token is valid.  Args:     profile: User profile extracted from the authorization token      Returns:     dict: Simple success response
         * @summary Verify Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyTokenApiTokenManagerVerifyGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyTokenApiTokenManagerVerifyGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TokenManagerApi.verifyTokenApiTokenManagerVerifyGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TokenManagerApi - factory interface
 * @export
 */
export const TokenManagerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TokenManagerApiFp(configuration)
    return {
        /**
         * Reveal a specific token\'s value to the authenticated owner
         * @summary Reveal Token
         * @param {string} tokenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revealTokenApiTokenManagerTokenIdRevealGet(tokenId: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.revealTokenApiTokenManagerTokenIdRevealGet(tokenId, options).then((request) => request(axios, basePath));
        },
        /**
         * HTML endpoint to manage authentication tokens
         * @summary Token Manager Ui
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenManagerUiApiTokenManagerGet(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.tokenManagerUiApiTokenManagerGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Simple endpoint to verify if a token is valid.  Args:     profile: User profile extracted from the authorization token      Returns:     dict: Simple success response
         * @summary Verify Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTokenApiTokenManagerVerifyGet(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.verifyTokenApiTokenManagerVerifyGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TokenManagerApi - object-oriented interface
 * @export
 * @class TokenManagerApi
 * @extends {BaseAPI}
 */
export class TokenManagerApi extends BaseAPI {
    /**
     * Reveal a specific token\'s value to the authenticated owner
     * @summary Reveal Token
     * @param {string} tokenId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenManagerApi
     */
    public revealTokenApiTokenManagerTokenIdRevealGet(tokenId: string, options?: RawAxiosRequestConfig) {
        return TokenManagerApiFp(this.configuration).revealTokenApiTokenManagerTokenIdRevealGet(tokenId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * HTML endpoint to manage authentication tokens
     * @summary Token Manager Ui
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenManagerApi
     */
    public tokenManagerUiApiTokenManagerGet(options?: RawAxiosRequestConfig) {
        return TokenManagerApiFp(this.configuration).tokenManagerUiApiTokenManagerGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Simple endpoint to verify if a token is valid.  Args:     profile: User profile extracted from the authorization token      Returns:     dict: Simple success response
     * @summary Verify Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenManagerApi
     */
    public verifyTokenApiTokenManagerVerifyGet(options?: RawAxiosRequestConfig) {
        return TokenManagerApiFp(this.configuration).verifyTokenApiTokenManagerVerifyGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TokensApi - axios parameter creator
 * @export
 */
export const TokensApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new access token for the current user
         * @summary Create Token
         * @param {TokenCreate} tokenCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTokenApiTokensPost: async (tokenCreate: TokenCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenCreate' is not null or undefined
            assertParamExists('createTokenApiTokensPost', 'tokenCreate', tokenCreate)
            const localVarPath = `/api/tokens/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OptionalHTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tokenCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a specific token belonging to the current user
         * @summary Delete Token
         * @param {string} tokenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTokenApiTokensTokenIdDelete: async (tokenId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenId' is not null or undefined
            assertParamExists('deleteTokenApiTokensTokenIdDelete', 'tokenId', tokenId)
            const localVarPath = `/api/tokens/{token_id}`
                .replace(`{${"token_id"}}`, encodeURIComponent(String(tokenId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OptionalHTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all active tokens for the current user
         * @summary List Tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTokensApiTokensGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tokens/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OptionalHTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TokensApi - functional programming interface
 * @export
 */
export const TokensApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TokensApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new access token for the current user
         * @summary Create Token
         * @param {TokenCreate} tokenCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTokenApiTokensPost(tokenCreate: TokenCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Token>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTokenApiTokensPost(tokenCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TokensApi.createTokenApiTokensPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a specific token belonging to the current user
         * @summary Delete Token
         * @param {string} tokenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTokenApiTokensTokenIdDelete(tokenId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTokenApiTokensTokenIdDelete(tokenId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TokensApi.deleteTokenApiTokensTokenIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all active tokens for the current user
         * @summary List Tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTokensApiTokensGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Token>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTokensApiTokensGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TokensApi.listTokensApiTokensGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TokensApi - factory interface
 * @export
 */
export const TokensApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TokensApiFp(configuration)
    return {
        /**
         * Create a new access token for the current user
         * @summary Create Token
         * @param {TokenCreate} tokenCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTokenApiTokensPost(tokenCreate: TokenCreate, options?: RawAxiosRequestConfig): AxiosPromise<Token> {
            return localVarFp.createTokenApiTokensPost(tokenCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a specific token belonging to the current user
         * @summary Delete Token
         * @param {string} tokenId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTokenApiTokensTokenIdDelete(tokenId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTokenApiTokensTokenIdDelete(tokenId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all active tokens for the current user
         * @summary List Tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTokensApiTokensGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<Token>> {
            return localVarFp.listTokensApiTokensGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TokensApi - object-oriented interface
 * @export
 * @class TokensApi
 * @extends {BaseAPI}
 */
export class TokensApi extends BaseAPI {
    /**
     * Create a new access token for the current user
     * @summary Create Token
     * @param {TokenCreate} tokenCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensApi
     */
    public createTokenApiTokensPost(tokenCreate: TokenCreate, options?: RawAxiosRequestConfig) {
        return TokensApiFp(this.configuration).createTokenApiTokensPost(tokenCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a specific token belonging to the current user
     * @summary Delete Token
     * @param {string} tokenId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensApi
     */
    public deleteTokenApiTokensTokenIdDelete(tokenId: string, options?: RawAxiosRequestConfig) {
        return TokensApiFp(this.configuration).deleteTokenApiTokensTokenIdDelete(tokenId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all active tokens for the current user
     * @summary List Tokens
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensApi
     */
    public listTokensApiTokensGet(options?: RawAxiosRequestConfig) {
        return TokensApiFp(this.configuration).listTokensApiTokensGet(options).then((request) => request(this.axios, this.basePath));
    }
}



